import { QUESTION_TYPE } from '../constants/constants';

export const STORIES = [
  {
    "grade": "1",
    "author": " ",
    "title": "Elephants",
    "storyId": "87654321-4321-dcba-4321-fedcba654321",
    "type": "listeningComprehension",
    "nonAudio": "true",
    "chapters": [
      {
        "phrases": [
          "read aloud video",
          "Trunk",
          "fun sun",
          "multi-purpose",
          "multi-purpose"
        ],
        "items": [
          {
            "type": "readAloudVideo",
            "assetURL": "https://amira-assets.s3.amazonaws.com/videos/jack-and-jill.mp4",
            "writtenInstructions": "Listen to the Story.",
          },
          {
            "type": "quiz",
            "questions": [
              {
                "type": "multi",
                "text": "What do baby elephants suck on instead of their thumb?",
                "readQuestion": "false",
                "feedbackMode": "false",
                "distractors": [
                  "Toes",
                  "Trunk",
                  "Ear",
                  "Nose"
                ],
                "correct": ["Trunk"]
              }
            ]
          },
          {
            "type": "quiz",
            "questions": [
              {
                "type": "multi",
                "distractorFormat": "multi",
                "text": "Which two of these words rhyme?",
                "readQuestion": "true",
                "distractors": [
                  "fun",
                  "jar",
                  "sun",
                  "cat"
                ],
                "correct": ["fun", "sun"]
              }
            ]
          },
          {
            "type": "quiz",
            "questions": [
              {
                "type": "cloze",
                "distractorFormat": "multi",
                "text": "An elephant's trunk is a ____ tool.",
                "readQuestion": "true",
                "feedbackMode": "true",
                "distractors": [
                  "showering",
                  "eating",
                  "multi-purpose"
                ],
                "correct": ["multi-purpose"],
              }
            ]
          },
          {
            "type": "quiz",
            "questions": [
              {
                "type": "cloze",
                "distractorFormat": "flat",
                "text": "An elephant's trunk is a <BLANK/> tool.",
                "readQuestion": "true",
                "distractors": [
                  "showering",
                  "eating",
                  "multi-purpose"
                ],
                "correct": ["multi-purpose"],
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "grade": "2",
    "author": " ",
    "title": "NWF 2",
    "storyId": "12345678-1234-abcd-1234-abcdef123456",
    "type": "nwf",
    "locale": "en-us",
    "chapters": [
      {
        "phrases": [
          "ob",
          "ak",
          "ig",
          "kal",
          "wuz",
          "ber",
          "ving",
          "slornt",
          "joibuk",
          "skorupski",
        ],
        "items": [
          {
            "type": "wordList",
            "writtenInstructions": "How would you say the make-believe word?",  //for now assume that the instructions are the same for both the example and the actual phrase
            "instructions": {
              "verbalInstructions": "<speak>I'm going to show you a list of make believe words. Read each make believe word as I show it to you. For example, here you would say: <break time=\"0.25s\"/> zim. Now it's your turn.</speak>",
              "type": "wordList",
              "text": "zim",
            },
            "timeoutInMS": 6000,
          },
          {
            "type": "wordList",
            "writtenInstructions": "How would you say the make-believe word?",
            "timeoutInMS": 6000,
          },
          {
            "type": "wordList",
            "writtenInstructions": "How would you say the make-believe word?",
            "timeoutInMS": 6000,
          },
          {
            "type": "wordList",
            "writtenInstructions": "How would you say the make-believe word?",
            "timeoutInMS": 6000,
          },
          {
            "type": "wordList",
            "writtenInstructions": "How would you say the make-believe word?",
            "timeoutInMS": 6000,
          },
          {
            "type": "wordList",
            "writtenInstructions": "How would you say the make-believe word?",
            "timeoutInMS": 6000,
          },
          {
            "type": "wordList",
            "writtenInstructions": "How would you say the make-believe word?",
            "timeoutInMS": 6000,
          },
          {
            "type": "wordList",
            "writtenInstructions": "How would you say the make-believe word?",
            "timeoutInMS": 6000,
          },
          {
            "type": "wordList",
            "writtenInstructions": "How would you say the make-believe word?",
            "timeoutInMS": 6000,
          },
          {
            "type": "wordList",
            "writtenInstructions": "How would you say the make-believe word?",
            "timeoutInMS": 6000,
          },
        ]
      }
    ]
  },
  {
    "grade": "2",
    "author": " ",
    "title": "Spanish NWF 2",
    "storyId": "12345678-1234-abcd-1234-abcdef131415",
    "type": "nwf",
    "locale": "es-mx",
    "chapters": [
      {
        "phrases": [
          "ob",
          "ak",
          "ig",
          "kal",
          "wuz",
          "ber",
          "ving",
          "slornt",
          "joibuk",
          "skorupski",
        ],
        "items": [
          {
            "type": "wordList",
            "writtenInstructions": "¿Cómo dirías la palabra de fantasía?",  //for now assume that the instructions are the same for both the example and the actual phrase
            "instructions": {
              "verbalInstructions": "Te voy a mostrar una lista de palabras de fantasía. Lea cada palabra de fantasía tal como se la muestro. Por ejemplo, aquí dirías: <break time=\"0.25s\"/> <mark name=\"skipTranslation: start\"/>zim.<mark name=\"skipTranslation: end\"/> Ahora es tu turno.",
              "type": "wordList",
              "text": "zim",
            },
            "timeoutInMS": 6000,
          },
          {
            "type": "wordList",
            "writtenInstructions": "¿Cómo dirías la palabra de fantasía?",
            "timeoutInMS": 6000,
          },
          {
            "type": "wordList",
            "writtenInstructions": "¿Cómo dirías la palabra de fantasía?",
            "timeoutInMS": 6000,
          },
          {
            "type": "wordList",
            "writtenInstructions": "¿Cómo dirías la palabra de fantasía?",
            "timeoutInMS": 6000,
          },
          {
            "type": "wordList",
            "writtenInstructions": "¿Cómo dirías la palabra de fantasía?",
            "timeoutInMS": 6000,
          },
          {
            "type": "wordList",
            "writtenInstructions": "¿Cómo dirías la palabra de fantasía?",
            "timeoutInMS": 6000,
          },
          {
            "type": "wordList",
            "writtenInstructions": "¿Cómo dirías la palabra de fantasía?",
            "timeoutInMS": 6000,
          },
          {
            "type": "wordList",
            "writtenInstructions": "¿Cómo dirías la palabra de fantasía?",
            "timeoutInMS": 6000,
          },
          {
            "type": "wordList",
            "writtenInstructions": "¿Cómo dirías la palabra de fantasía?",
            "timeoutInMS": 6000,
          },
          {
            "type": "wordList",
            "writtenInstructions": "¿Cómo dirías la palabra de fantasía?",
            "timeoutInMS": 6000,
          },
        ]
      }
    ]
  },
  {
    "grade": "2",
    "author": " ",
    "title": "Spelling 2",
    "storyId": "12345678-1234-abcd-1234-abcdef123789",
    "type": "spelling",
    "nonAudio": "true",
    "chapters": [
      {
        "phrases": [
          "cat",
          "ball",
          "bat",
          "tree",
          "bear",
        ],
        "items": [
          {
            "type": "spelling",
            "writtenInstructions": "Type the word, then click the green arrow",  //for now assume that the instructions are the same for both the example and the actual phrase
            "instructions": {
              "verbalInstructions": "<speak>I'm going to read you a word. After I say the word, I'll read a sentence with the word in it and then say the word again. Wait until I've finished to begin typing. Your first word is cat. The cat chased the mouse. Cat.</speak>",
              "type": "spelling",
              "repeatable": true,
              "repeatVariation": "Cat. The cat chased the mouse. Cat."
            },
            "timeoutInMS": 1000000,
          },
          {
            "type": "spelling",
            "writtenInstructions": "Type the word, then click the green arrow",
            "instructions": {
              "verbalInstructions": "<speak>Ball. Tim threw the ball. Ball.</speak>",
              "type": "spelling",
              "repeatable": true
            },
            "timeoutInMS": 10000,
          },
          {
            "type": "spelling",
            "writtenInstructions": "Type the word, then click the green arrow",
            "instructions": {
              "verbalInstructions": "<speak>Bat. He hit the ball with the bat. Bat.</speak>",
              "type": "spelling",
              "repeatable": true
            },
            "timeoutInMS": 10000,
          },
          {
            "type": "spelling",
            "writtenInstructions": "Type the word, then click the green arrow",
            "instructions": {
              "verbalInstructions": "<speak>Tree. The squirrel ran up the tree. Tree.</speak>",
              "type": "spelling",
              "repeatable": true
            },
            "timeoutInMS": 10000,
          },
          {
            "type": "spelling",
            "writtenInstructions": "Type the word, then click the green arrow",
            "instructions": {
              "verbalInstructions": "<speak>Bear. The bear hibernates in the winter. Bear.</speak>",
              "type": "spelling",
              "repeatable": true
            },
            "timeoutInMS": 10000,
          },
        ]
      }
    ]
  },
  {
    "grade": "2",
    "author": " ",
    "title": "Spanish Spelling 2",
    "locale": "es-mx",
    "storyId": "12345678-1234-abcd-1234-abcdef101112",
    "type": "spelling",
    "nonAudio": "true",
    "chapters": [
      {
        "phrases": [
          "cat",
          "ball",
          "bat",
          "tree",
          "bear",
        ],
        "items": [
          {
            "type": "spelling",
            "writtenInstructions": "Escriba la palabra, luego haz clic en la flecha verde",  //for now assume that the instructions are the same for both the example and the actual phrase
            "instructions": {
              "verbalInstructions": "Te voy a leer una palabra. Después de decir la palabra, leeré una oración con la palabra y luego la volveré a decir. Espere hasta que termine de comenzar a escribir. Tu primera palabra es <mark name=\"skipTranslation: start\"/>cat. The cat chased the mouse. Cat.<mark name=\"skipTranslation: end\"/>",
              "type": "spelling",
              "repeatable": true,
              "repeatVariation": "<mark name=\"skipTranslation: start\"/>Cat. The cat chased the mouse. Cat.<mark name=\"skipTranslation: end\"/>"
            },
            "timeoutInMS": 1000000,
          },
          {
            "type": "spelling",
            "writtenInstructions": "Escriba la palabra, luego haz clic en la flecha verde",
            "instructions": {
              "verbalInstructions": "<mark name=\"skipTranslation: start\"/>Ball. Tim threw the ball. Ball.<mark name=\"skipTranslation: end\"/>",
              "type": "spelling",
              "repeatable": true
            },
            "timeoutInMS": 10000,
          },
          {
            "type": "spelling",
            "writtenInstructions": "Escriba la palabra, luego haz clic en la flecha verde",
            "instructions": {
              "verbalInstructions": "<mark name=\"skipTranslation: start\"/>Bat. He hit the ball with the bat. Bat.<mark name=\"skipTranslation: end\"/>",
              "type": "spelling",
              "repeatable": true
            },
            "timeoutInMS": 10000,
          },
          {
            "type": "spelling",
            "writtenInstructions": "Escriba la palabra, luego haz clic en la flecha verde",
            "instructions": {
              "verbalInstructions": "<mark name=\"skipTranslation: start\"/>Tree. The squirrel ran up the tree. Tree.<mark name=\"skipTranslation: end\"/>",
              "type": "spelling",
              "repeatable": true
            },
            "timeoutInMS": 10000,
          },
          {
            "type": "spelling",
            "writtenInstructions": "Escriba la palabra, luego haz clic en la flecha verde",
            "instructions": {
              "verbalInstructions": "<mark name=\"skipTranslation: start\"/>Bear. The bear hibernates in the winter. Bear.<mark name=\"skipTranslation: end\"/>",
              "type": "spelling",
              "repeatable": true
            },
            "timeoutInMS": 10000,
          },
        ]
      }
    ]
  },
  {
    "grade": "0",
    "author": " ",
    "title": "Dyslexia K",
    "storyId": "ff4b1840-bf93-11e9-9e28-857ed064d0c9",
    "type": "dyslexia",
    "chapters": [
      {
        "phrases": [
          "u_sound",
          "k_sound",
          "s_sound",
          "y_sound",
          "p_sound",
          "e_sound",
          "d_sound",
          "z_sound",
          "i_sound",
          "x_sound",
          "tick",
          "home",
          "loud",
          "think",
          "play",
          "stick",
          "back",
          "mash",
          "two seven four five three eight four two five eight three seven two eight four three five seven four eight two seven five three five two eight three four seven three two five eight seven four"
        ],
        "items": [
          {
            "type": "letterSound",
            "writtenInstructions": "What sound does the letter make?",  //for now assume that the instructions are the same for both the example and the actual phrase
            "instructions": {
              "verbalInstructions": "Please say the sound made by each letter I show you. For example, for the letter gee you would say ga. Ok. Now it's your turn!",
              "type": "sound",
              "text": "g_sound",
            },
            "timeoutInMS": 6000,
          },
          {
            "type": "letterSound",
            "writtenInstructions": "What sound does the letter make?",
            "timeoutInMS": 6000,
          },
          {
            "type": "letterSound",
            "writtenInstructions": "What sound does the letter make?",
            "timeoutInMS": 6000,
          },
          {
            "type": "letterSound",
            "writtenInstructions": "What sound does the letter make?",
            "timeoutInMS": 6000,
          },
          {
            "type": "letterSound",
            "writtenInstructions": "What sound does the letter make?",
            "timeoutInMS": 6000,
          },
          {
            "type": "letterSound",
            "writtenInstructions": "What sound does the letter make?",
            "timeoutInMS": 6000,
          },
          {
            "type": "letterSound",
            "writtenInstructions": "What sound does the letter make?",
            "timeoutInMS": 6000,
          },
          {
            "type": "letterSound",
            "writtenInstructions": "What sound does the letter make?",
            "timeoutInMS": 6000,
          },
          {
            "type": "letterSound",
            "writtenInstructions": "What sound does the letter make?",
            "timeoutInMS": 6000,
          },
          {
            "type": "letterSound",
            "writtenInstructions": "What sound does the letter make?",
            "timeoutInMS": 6000,
          },
          {
            "type": "blending",
            "videoURL": "https://s3.amazonaws.com/amira-assets/blending/tick.mp4",
            "writtenInstructions": "What is the word?",
            "instructions": {
              "verbalInstructions": "My friend in the video is going to say some words very slowly, one part at a time. After each video, you should say the word. For example, if my friend said <phoneme alphabet=\"ipa\" ph=\"mˈaɪ\"/> <break time=\"0.7s\"/> <phoneme alphabet=\"ipa\" ph=\"s\"/> <break time=\"0.3s\"/>, then you should say, mice. Ok, get ready. Now it's your turn.",
              "type": "blending",
              "videoURL": "https://s3.amazonaws.com/amira-assets/blending/tick.mp4",
              "writtenInstructions": "What is the word?"
            },
            "timeoutInMS": 6000,
          },
          {
            "type": "blending",
            "writtenInstructions": "What is the word?",
            "videoURL": "https://s3.amazonaws.com/amira-assets/blending/home.mp4",
            "timeoutInMS": 6000,
          },
          {
            "type": "blending",
            "writtenInstructions": "What is the word?",
            "videoURL": "https://s3.amazonaws.com/amira-assets/blending/loud.mp4",
            "timeoutInMS": 6000,
          },
          {
            "type": "blending",
            "writtenInstructions": "What is the word?",
            "videoURL": "https://s3.amazonaws.com/amira-assets/blending/think.mp4",
            "timeoutInMS": 6000,
          },
          {
            "type": "blending",
            "writtenInstructions": "What is the word?",
            "videoURL": "https://s3.amazonaws.com/amira-assets/blending/play.mp4",
            "timeoutInMS": 6000,
          },
          {
            "type": "blending",
            "writtenInstructions": "What is the word?",
            "videoURL": "https://s3.amazonaws.com/amira-assets/blending/stick.mp4",
            "timeoutInMS": 6000,
          },
          {
            "type": "blending",
            "writtenInstructions": "What is the word?",
            "videoURL": "https://s3.amazonaws.com/amira-assets/blending/back.mp4",
            "timeoutInMS": 6000,
          },
          {
            "type": "blending",
            "writtenInstructions": "What is the word?",
            "videoURL": "https://s3.amazonaws.com/amira-assets/blending/mash.mp4",
            "timeoutInMS": 6000,
          },
          {
            "type": "ran",
            "imageURL": "https://s3.amazonaws.com/amira-assets/ran/ran_k.jpg",
            "writtenInstructions": "Say the numbers as fast as you can...",
            "instructions": {
              "verbalInstructions": "I'm going to show you some things to name. For example, you may see some numbers like the ones on the screen now. You should say these numbers as fast as you can, going from left to right and top to bottom. So, you would say, 1 2 3 4 5 6 7. OK, start naming the numbers as fast as you can",
              "type": "word",
              "text": "1 2 3 4 5 6 7",
              "writtenInstructions": "Say the numbers as fast as you can...",
              "transition": "readySetGo",
            },
            "timeoutInMS": 60000,
          }
        ]
      }
    ]
  },
  {
    "grade": "1",
    "author": " ",
    "title": "Dyslexia 1",
    "storyId": "50a0c7d0-bf94-11e9-9e28-857ed064d0c9",
    "type": "dyslexia",
    "chapters": [
      {
        "phrases": [
          "u_sound",
          "g_sound",
          "e_sound",
          "q_sound",
          "h_sound",
          "c_sound",
          "v_sound",
          "n_sound",
          "l_sound",
          "w_sound",
          "name",
          "rice",
          "back",
          "great",
          "police",
          "become",
          "summer",
          "school",
          "boom",
          "mass",
          "wall",
          "stood",
          "blunt",
          "street",
          "two seven four five three eight four two five eight three seven two eight four three five seven four eight two seven five three five two eight three four seven three two five eight seven four"
        ],
        "items": [
          {
            "type": "letterSound",
            "instructions": {
              "verbalInstructions": "Please say the sound made by each letter I show you. For example, for the letter gee you would say ga",
              "type": "sound",
              "text": "g_sound",
            }
          },
          {"type": "letterSound"},
          {"type": "letterSound"},
          {"type": "letterSound"},
          {"type": "letterSound"},
          {"type": "letterSound"},
          {"type": "letterSound"},
          {"type": "letterSound"},
          {"type": "letterSound"},
          {"type": "letterSound"},
          {
            "type": "wordList",
            "instructions": {
              "verbalInstructions": "<speak>Read each word as I show it to you. For example, here you would say: <break time=\"0.25s\"/> told</speak>",
              "type": "word",
              "text": "told"
            }
          },
          {"type": "wordList"},
          {"type": "wordList"},
          {"type": "wordList"},
          {"type": "wordList"},
          {"type": "wordList"},
          {"type": "wordList"},
          {"type": "wordList"},
          {
            "type": "blending",
            "videoURL": "https://s3.amazonaws.com/amira-assets/blending/boom.mp4",
            "instructions": {
              "verbalInstructions": "Listen to my friend sound out the parts of some words. You should then combine these parts and say the word they make. For example, my friend might say <phoneme alphabet=\"ipa\" ph=\"mˈaɪ\"/> <break time=\"0.7s\"/> <phoneme alphabet=\"ipa\" ph=\"s\"/> <break time=\"0.3s\"/> and then you should say mice.",
              "type": "word",
              "text": "Listen to Amira"
            }
          },
          {
            "type": "blending",
            "videoURL": "https://s3.amazonaws.com/amira-assets/blending/mass.mp4"
          },
          {
            "type": "blending",
            "videoURL": "https://s3.amazonaws.com/amira-assets/blending/wall.mp4"
          },
          {
            "type": "blending",
            "videoURL": "https://s3.amazonaws.com/amira-assets/blending/stood.mp4"
          },
          {
            "type": "blending",
            "videoURL": "https://s3.amazonaws.com/amira-assets/blending/blunt.mp4"
          },
          {
            "type": "blending",
            "videoURL": "https://s3.amazonaws.com/amira-assets/blending/street.mp4"
          },
          {
            "type": "ran",
            "imageURL": "https://s3.amazonaws.com/amira-assets/ran/ran_k.jpg",
            "instructions": {
              "verbalInstructions": "I'm going to show you some things to name. For example, you may see some numbers like the ones on the screen now. You should say these numbers as fast as you can, going from left to right and top to bottom. So, you would say, 1 2 3 4 5 6 7. OK, start naming the numbers as fast as you can",
              "type": "word",
              "text": "1 2 3 4 5 6 7",
              "transition": "readySetGo",
            }
          }
        ]
      }
    ]
  },
  {
    "grade": "2",
    "author": " ",
    "title": "Dyslexia 2",
    "storyId": "a04c70e0-bf94-11e9-9e28-857ed064d0c9",
    "type": "dyslexia",
    "chapters": [
      {
        "phrases": [
          "told",
          "rice",
          "hair",
          "held",
          "born",
          "child",
          "lesson",
          "flight",
          "hurry",
          "action",
          "worse",
          "world",
          "two seven four five three eight four two five eight three seven two eight four three five seven four eight two seven five three five two eight three four seven three two five eight seven four"
        ],
        "items": [
          {
            "type": "wordList",
            "instructions": {
              "type": "wordList",
              "instructions": {
                "verbalInstructions": "<speak>Read each word as I show it to you. For example, here you would say: <break time=\"0.25s\"/> told</speak>",
                "type": "word",
                "text": "told"
              }
            },
          },
          {"type": "wordList"},
          {"type": "wordList"},
          {"type": "wordList"},
          {"type": "wordList"},
          {"type": "wordList"},
          {"type": "wordList"},
          {"type": "wordList"},
          {"type": "wordList"},
          {"type": "wordList"},
          {"type": "wordList"},
          {"type": "wordList"},
          {
            "type": "ran",
            "imageURL": "https://s3.amazonaws.com/amira-assets/ran/ran_k.jpg",
            "instructions": {
              "verbalInstructions": "I'm going to show you some things to name. For example, you may see some numbers like the ones on the screen now. You should say these numbers as fast as you can, going from left to right and top to bottom. So, you would say, 1 2 3 4 5 6 7. OK, start naming the numbers as fast as you can",
              "type": "word",
              "text": "1 2 3 4 5 6 7",
              "transition": "readySetGo",
            }
          }
        ]
      }
    ]
  },
  {
    "grade": "3",
    "author": " ",
    "title": "Dyslexia 3",
    "storyId": "ad3fdee0-bf94-11e9-9e28-857ed064d0c9",
    "type": "dyslexia",
    "chapters": [
      {
        "phrases": [
          "beside",
          "rules",
          "cried",
          "insect",
          "voice",
          "early",
          "sugar",
          "straw",
          "healthy",
          "earn",
          "bodies",
          "station",
          "caught",
          "hours",
          "island",
          "measure",
          "signal",
          "coming",
          "hair",
          "beautiful",
          "two seven four five three eight four two five eight three seven two eight four three five seven four eight two seven five three five two eight three four seven three two five eight seven four"
        ],
        "items": [
          {
            "type": "wordList",
            "instructions": {
              "verbalInstructions": "<speak>Read each word as I show it to you. For example, here you would say: <break time=\"0.25s\"/> told</speak>",
              "type": "word",
              "text": "told"
            }
          },
          {"type": "wordList"},
          {"type": "wordList"},
          {"type": "wordList"},
          {"type": "wordList"},
          {"type": "wordList"},
          {"type": "wordList"},
          {"type": "wordList"},
          {"type": "wordList"},
          {"type": "wordList"},
          {"type": "wordList"},
          {"type": "wordList"},
          {"type": "wordList"},
          {"type": "wordList"},
          {"type": "wordList"},
          {"type": "wordList"},
          {"type": "wordList"},
          {"type": "wordList"},
          {"type": "wordList"},
          {"type": "wordList"},
          {
            "type": "ran",
            "imageURL": "https://s3.amazonaws.com/amira-assets/ran/ran_k.jpg",
            "instructions": {
              "verbalInstructions": "I'm going to show you some things to name. For example, you may see some numbers like the ones on the screen now. You should say these numbers as fast as you can, going from left to right and top to bottom. So, you would say, 1 2 3 4 5 6 7. OK, start naming the numbers as fast as you can",
              "type": "word",
              "text": "1 2 3 4 5 6 7",
              "transition": "readySetGo",
            }
          }
        ]
      }
    ]
  },
  {
    "grade": "3",
    "author": " ",
    "title": "Elephants",
    "storyid": "b940c190-725b-11e9-9048-67e3d3231e74",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "Elephants eat between 250 and 350 pounds of food a day.",
          "They need a lot of food to maintain their huge six-ton bodies.",
          "Because of that, they spend nineteen hours a day eating.",
          "They eat almost any kind of plant.",
          "Elephants eat by shoveling food into their mouths with their trunks.",
          "Their trunks act like a fork for eating food and like a straw for drinking water.",
          "Besides being used for eating and drinking, the trunk can be used in many other ways.",
          "An elephant can use its trunk like a tool.",
          "It can be used like an ax to break tree branches or as a weapon against predators such as lions.",
          "It can also be used as an arm to comfort a friend or hug a baby.",
          "Baby elephants even suck their trunks just like human babies suck their thumbs.",
          "Water is very important to elephants.",
          "They spend a lot of time at the water hole.",
          "At the water hole, they drink, cool off, and take a bath.",
          "They also spend time swimming in the water.",
          "Elephants use their trunks as a snorkel when they swim.",
          "They spray water through their trunks like a showerhead.",
          "They dust themselves with a shower of dirt using their trunk.",
          "The dust keeps them from being sunburned and keeps annoying insects away.",
          "An elephant's trunk is a useful tool."
        ]
      }
    ],
    "questions": [
      {
        "text": "Baby elephants suck on their ____ like human babies suck on their thumb.",
        "distractors": [
          "Toes",
          "Trunk",
          "Ear"
        ],
        "correct": "Trunk"
      },
      {
        "text": "An elephant's trunk is a ____ tool.",
        "distractors": [
          "showering",
          "eating",
          "multi-purpose"
        ],
        "correct": "multi-purpose"
      }
    ]
  },
  {
    "grade": "3",
    "author": " ",
    "title": "Sea of Capri",
    "storyid": "c79b10e0-7fb4-11e9-82b6-b984767f10dc",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "Once upon a time in Capri lived a little girl, called Dorina.",
          "She loved stories about the Sea. She wished she could, one day, climb into one of these stories and become its heroine!",
          "Because Dorina was a kind hearted girl, the Great Mermaid, Queen of the Seas, decided to please her.",
          "It was a grey, rainy day and, after doing her homework, Dorina decided to indulge in reading the new book she had been given as a present: The Enchanted Sea of Capri.",
          "Dorina opened the book.",
          "All of a sudden, a splash of water flowed from the pages.",
          "The little girl instinctively threw the book down.",
          "Dorina was suddenly soaked with water.",
          "Looking down at her wet clothes, she noticed a tiny starfish among the folds.",
          "It was smaller than her hand.",
          "The two tiny eyes and the mouth of the little animal were amazing.",
          "Dorina wasn't scared at all!",
          "Dorina picked the tiny starfish with her hands and asked: \"Who are you?\"",
          "And, the starfish replied: \"I am Five Points and I come from the wonderful Blue Sea of Capri!\"",
          "\"You must be Dorina! I was sent by the Great Mermaid to make your wish come true.\"",
          "\"From underneath the water we always see you reading books about us and imagining playing in the seabed of your beautiful island!\"",
          "\"Today is your lucky day! Hold on to me!\".",
          "And Dorina answered: \"But, how can I hold on to you if you are so tiny?\"",
          "Five Points smiled and exclaimed: \"You are right! You must utter the magic formula for shrinking!\"",
          "So, repeat with me: \"OH GREAT MERMAID OF THE SEA, AT THIS VERY SAME MOMENT, CHANGE MY NATURE AND ME, AND VERY VERY SMALL LET ME BE!\"",
          "That's the formula! Come on, Dorina, repeat it with me!\" And Dorina, full of excitement, exclaimed the formula.",
          "Dorina started getting smaller and smaller.",
          "She slipped out of her wet clothes and, in a while, she turned into a tiny sea snail.",
          "She was now even smaller than the starfish!",
          "\"Listen carefully and don't be afraid. Lets jump into the book you were reading.\"",
          "\"We have to find the word diving and open the little magic door which will lead us into the Sea.\" Are you ready? \"Start reading!\"",
          "Dorina started reading: \"On that day the little fish decided to … DIVE\".",
          "Five Points cried: \"Here's the moment! The magic door is opening! Jump.\"",
          "Down, down, down the snail and the starfish fell.",
          "Five Points and Dorina found themselves swimming in the fantastic, immense BLUE SEA of Capri!",
          "Dorina felt as if she was the happiest snail girl in the world!",
          "The sea of Capri! Who could imagine the sea was so huge and welcoming and rich!",
          "So many colors! The sea wasn't blue only, but sparkled with thousands of nuances and shades!",
          "Still hanging onto Five Points, Dorina looked around.",
          "With her heart full of joy, she admired the variety of the corals, the fish, the underwater rocks, the seaweeds and much, much more!",
          "Everything under the sea was shining and moved sinuously.",
          "Colonies of beautiful black sea urchins waved as they swam past.",
          "Dorina couldn't stop marveling at all that was around her.",
          "She told Five Points: \"I had an idea that life in the sea was great, but never imagined it was so gorgeous!\"",
          "A bit tired, Five Points said: \"Dorina, let's slow down, let's let the current of the water carry us to the Rock House.\" And so they surrendered themselves to the sea and began to float towards the Rock House of the Great Mermaid, Queen of the Sea, under the Blue Grotto."
        ],
        "items": [
          {
            "type": "phrase",
            "predictionQuestions": [ //prediction intervention questions
              {
                "type": "flatMulti",
                "text": "Can you guess what Dorina's favorite stories were about?",
                "readQuestion": "true",
                "feedbackMode": "true",
                "distractors": [
                  "Desert",
                  "Sea",
                  "Solar System",
                ],
                "correct": ["Sea"]
              }
            ],
            "questions": [ //comprehension intervention questions
              {
                "type": "flatMulti",
                "text": "Where did Dorina live?",
                "readQuestion": "true",
                "feedbackMode": "true",
                "distractors": [
                  "Chicago",
                  "South America",
                  "Capri",
                  "Sweden"
                ],
                "correct": ["Capri"]
              }
            ],
          },
          {
            "type": "phrase"
          },
          {
            "type": "phrase",
            "questions": [
              {
                "type": "cloze",
                "text": "Dorina loved stories about the <BLANK/>",
                "distractors": [
                  "Forest",
                  "Mountains",
                  "Sea"
                ],
                "correct": ["Sea"]
              },
              {
                "type": "cloze",
                "text": "Dorina was a <BLANK/> hearted girl",
                "distractors": [
                  "Evil",
                  "Kind",
                  "Silly",
                  "Angry"
                ],
                "correct": ["Kind"]
              }
            ]
          },
        ]
      }
    ],
    "questions": [
      {
        "text": "Dorina becomes a ____, thanks to Five Points.",
        "distractors": [
          "starfish",
          "mermaid",
          "snail"
        ],
        "correct": "snail"
      },
      {
        "text": "The Sea of Capri is ____, based on the story.",
        "distractors": [
          "dark and brown",
          "colorful and blue",
          "glowing and green"
        ],
        "correct": "colorful and blue"
      }
    ]
  },
  {
    "grade": "3",
    "author": " ",
    "title": "Understanding Big Cat Species",
    "storyid": "c0617c10-725d-11e9-9048-67e3d3231e74",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "In Africa, they say that a lion's roar means \"Whose land is this? It is mine, mine, mine!\".",
          "Our natural response to the lion's ancient challenge is to edge closer to the campfire.",
          "The lion is the king of the savannah, but to a considerable degree, cats are cats around the world.",
          "Watch a neighborhood tomcat stalking a squirrel and you see in miniature a tiger stalking deer on the meadows of India, or a panther hunting boar on the pampas.",
          "And yet, partly because they are so majestic, the big cats are different from the neighbor's pet feline.",
          "For millions of years, the large cat species had nothing to fear but one another.",
          "Big cats, like tigers, were the lords of all they surveyed.",
          "But the invention of gunpowder changed that equation forever.",
          "Once, lions and tigers hunted people.",
          "Now, they have become the prey.",
          "Fortunately, we understand that if large feline species like the lion, panther, cougar and tiger are to avoid extinction, we need to study them and then put that knowledge to use, conserving their habitats and protecting them from poachers.",
          "Big cats are nature's virtuoso predators.",
          "A grizzly bear may have a size advantage over a siberian tiger, but the tiger is far more agile.",
          "A wolf may have a better sense of smell than a jaguar, but a jaguar has the muscle to handle large prey alone.",
          "Cats combine excellent night vision, sharp hearing and enormous physical strength.",
          "Their graceful movements and camouflage colors make them stealthy.",
          "Cats hunt to survive.",
          "Animals that consume grass and leaves have stomachs capable of giving bacteria the time to break down complex plant sugars into simpler sugars animals amenable to digestion.",
          "Cats, on the other hand, have a short digestive tract that quickly breaks down meat and extracts energy.",
          "Cats cannot survive on blades of grass.",
          "In general, large predators require intelligence to be successful as hunters, and cats are no exception.",
          "The big cats are among the most intelligent species on Earth.",
          "They rank just behind primates (monkeys and apes) and cetaceans (whales and dolphins).",
          "Lions use group strategies to tackle large and dangerous prey like water buffalo.",
          "All cats are innately curious and learn quickly.",
          "Mother cats invest one to two years teaching their offspring the essential behaviors needed for survival as a predator.",
          "Big cats are found on all continents but Australia and Antarctica.",
          "But, while they can be found everywhere, they are safe nowhere.",
          "Every species of large at is now endangered.",
          "To keep these superb predators around, governments have banned hunting and zoos have initiated breeding programs.",
          "Cats and humans have a long history.",
          "For many years the domestic cat was described as a separate species from all other cats.",
          "House cats are now considered a subspecies (a slight variation) of the Wildcat.",
          "Archeological evidence shows people and cats have lived together for the past 8,000 years.",
          "Ancient Egyptians believed cats were the children of a Goddess.",
          "When a pet cat died, family members showed grief by shaving off their eyebrows, and cats were routinely mummified and laid to rest with great sadness and reverence.",
          "Only the domestic cat is truly tame.",
          "While other species of cats have sometimes been treated as pets, none have ever been completely domesticated.",
          "The proper term for cats such as lions or cheetahs that accept human companionship is \"human socialized\".",
          "This indicates that these animals still possess their entire range of wild instincts.",
          "The majestic lion is the embodiment of wild Africa.",
          "They are bold, ruggedly beautiful, and fierce on the hunt.",
          "Yet, lions are tender to their young and loyal to their companions.",
          "Not so long ago, the \"king of beasts\" roamed vast swaths of earth, including parts of Europe.",
          "Today, the lion's range is confined to the flat, grassy savannahs in the African countries of Kenya, South Africa, Tanzania, Zambia, and Zimbabwe.",
          "A lonely few remain in remote forests in India.",
          "What are the characteristics that make lions, lions?",
          "They have tawny fur.",
          "Male lions are larger than the lionesses, weighing as much as five men.",
          "The comparatively slender lioness usually weighs about as much as three and a half men.",
          "Adult males can also be recognized by the furry mane around their heads and down their necks.",
          "No other big cat species features such a dramatic difference in appearance between males and females.",
          "Both lions and lionesses have tufts on the end of their tails, something no other cat has.",
          "If you can ever get close enough to the tail of a male lion, you will feel a sharp bone tucked into the tail tuft.",
          "The muzzle of a lion is like a fingerprint - no two lions have the same pattern of whiskers.",
          "Lions say hello by rubbing cheeks.",
          "They say goodbye by tugging on each other's stomachs with their teeth.",
          "But, the truly defining characteristic of lions is the roar.",
          "The lion is the loudest of the cats; a roar can be heard up to five miles away."
        ]
      }
    ],
    "questions": [
      {
        "text": "Lions live in ____.",
        "distractors": [
          "the jungle",
          "the savannah",
          "the pampas"
        ],
        "correct": "the savannah"
      },
      {
        "text": "Big cats are ____ intelligent than monkeys.",
        "distractors": [
          "more",
          "a lot less",
          "a little less"
        ],
        "correct": "a little less"
      }
    ]
  },
  {
    "grade": "3",
    "author": " ",
    "title": "Animals",
    "storyid": "003c4110-725b-11e9-9048-67e3d3231e74",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "Farmers and ranchers raise animals for many uses.",
          "Some raise dairy cows for their milk, and some raise cattle for their meat.",
          "The cattle that are raised for their meat are sold at the market.",
          "Some other animals provide transportation because many ranchers ride horses to check their fences and to look for lost cattle.",
          "Many farmers eat the pigs and chickens that they raise, while others sell them for money.",
          "Sheep and goats are raised for their fur that can be sold to make clothing.",
          "Both sheep and goat fur are used to make warm winter clothes.",
          "Animals are raised on farms and ranches for many uses."
        ]
      }
    ],
    "questions": [
      {
        "text": "Clothes are made from ____ fur.",
        "distractors": [
          "goat and horse",
          "sheep and cattle",
          "goat and sheep"
        ],
        "correct": "goat and sheep"
      },
      {
        "text": "Horses are used for ____.",
        "distractors": [
          "transportation",
          "raising money",
          "many things"
        ],
        "correct": "transportation"
      }
    ]
  },
  {
    "grade": "3",
    "author": " ",
    "title": "Spiders Are Really Arachnids",
    "storyid": "204c35d0-7118-11e9-84af-87f1ff3e5777",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "My little sister is afraid of spiders.",
          "She says they are big ugly bugs that can bite off your nose.",
          "My little sister is so silly!",
          "Spiders are not bugs.",
          "Spiders are not even insects.",
          "Spiders are so special that they have a big long name that is hard to say.",
          "Spiders are called arachnids.",
          "You have to sound out that long word the first few times, but then it kind of rolls off your tongue.",
          "It sounds like a-rack-nids!",
          "We studied spiders at school last month.",
          "Arachnids have two body parts and eight legs.",
          "Insects have three body parts and have only six legs.",
          "An insect can never have more than two eyes, but arachnids or spiders can have as many as eight eyes.",
          "If a spider used his eight eyes to look at my little sister's nose, he would not want to bite it off.",
          "That poor arachnid would run the other way!",
          "I wonder if spiders have little sisters who are afraid of boys!"
        ]
      }
    ],
    "questions": [
      {
        "text": "The number of ____ is one big difference between arachnids and bugs.",
        "distractors": [
          "mouths",
          "eyes",
          "noses"
        ],
        "correct": "eyes"
      },
      {
        "text": "Another difference is the number of ____.",
        "distractors": [
          "body parts",
          "teeth",
          "tongues"
        ],
        "correct": "body parts"
      }
    ]
  },
  {
    "grade": "3",
    "author": " ",
    "title": "Frogs and Toads",
    "storyid": "3879c0c0-5587-11e9-b3e5-f17a2d74382b",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "Have you ever wondered what the difference is between a frog and a toad? Even though they both live on land and in water, there are many differences.",
          "Frogs spend most of their time in the water.",
          "They usually live in ponds or marshes.",
          "Toads live on dry land.",
          "Frogs have smooth, moist skin.",
          "They have to live in the water in order to keep their skin moist.",
          "The toad's skin is dry and bumpy and provides protection from the sun.",
          "Frogs and toads come in many different colors.",
          "However, both are often brown or dark green.",
          "Frogs can have stripes or other colorful markings.",
          "Both the frog and toad can shoot out their sticky tongues to catch insects.",
          "They swallow their food whole and blink.",
          "They do this because they use their eyeballs to push the food down their throats.",
          "Frogs can jump farther than toads.",
          "They also have webbed feet to help them swim.",
          "Both frogs and toads lay their eggs in water.",
          "Toads lay their eggs in long strings, and frogs lay their eggs in shapeless blobs.",
          "The eggs hatch into tadpoles.",
          "The tadpole has gills for breathing under water and it has a tail.",
          "It looks like a fish.",
          "After a few weeks, tadpoles grow legs and lose their tails.",
          "Lungs replace their gills, so they can breathe air.",
          "They are then ready to leave the water.",
          "As you can see, even though frogs and toads are different, they are alike in many ways."
        ]
      }
    ],
    "questions": [
      {
        "text": "Frogs love the ____.",
        "distractors": [
          "land",
          "water",
          "air"
        ],
        "correct": "water"
      },
      {
        "text": "Toads don't ____ frogs.",
        "distractors": [
          "shoot their tongue like",
          "live as long as",
          "jump as far as"
        ],
        "correct": "jump as far as"
      }
    ]
  },
  {
    "grade": "3",
    "author": " ",
    "title": "Don't Talk to the Parrot!",
    "storyid": "18094cc0-4d17-11e9-a389-d7abbd0baf81",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "Jada's oven didn't work so she called to fix it.",
          "Since she had to go to work in the morning, she left a note for the repairman, Ben.",
          "Ben arrived at 9 a.m. and read the note on the door.",
          "'The key is with my neighbor. Leave a bill and I will pay you tonight.'",
          "'Don't worry about my dog Rex. He won't bother you.'",
          "'But, do NOT talk to my parrot! Do not say one word to the parrot!'",
          "When Ben unlocked the door he met Rex, the most gigantic, meanest looking dog he had ever seen.",
          "But Rex was very obedient.",
          "He just sat there and watched Ben labor.",
          "The parrot, however, drove Ben crazy.",
          "The macaw squawked and screeched and called him rude names.",
          "Finally, Ben couldn't stand it any longer.",
          "He yelled, 'Be quiet, you gaudy, vapid bird!'",
          "The parrot replied, 'Go get him, Rex!'",
          "A frightened Ben barely made it out the door before Rex could inflict any harm.",
          "He never did finish repairing Jada's oven, and he didn't plan on going back."
        ]
      }
    ],
    "questions": []
  },
  {
    "grade": "3",
    "author": " ",
    "title": "The Day My Father Met Some Tigers",
    "storyid": "d67823e0-7326-11e9-b491-3358089dfb6b",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "The river was very wide and muddy, and the jungle was very gloomy and dense.",
          "The trees grew close to each other, and what room there was between them was taken up by great high ferns with sticky leaves.",
          "My father was then just a little boy, all alone in that jungle.",
          "He hated to leave the beach and walk into the dark.",
          "But he knew if he was ever to get home he had to find help.",
          "So, he decided to walk along the river bank where at least the jungle wasn't quite so thick.",
          "He ate three tangerines, and put on his rubber boots.",
          "My father tried to follow the river bank but it was very swampy, and as he went farther the swamp became deeper.",
          "When it was almost as deep as his boot tops he got stuck in the oozy, mucky mud.",
          "My father tugged and tugged, and nearly pulled his boots right off, but at last he managed to wade to a drier place.",
          "Here the jungle was so thick that he could hardly see where the river was.",
          "He unpacked his compass and figured out the direction he should walk in order to stay near the river.",
          "But he didn't know that the river made a very sharp curve away from him just a little way beyond, and so as he walked straight ahead he was getting farther and farther away from the river.",
          "It was very hard to walk in the jungle.",
          "The sticky leaves of the ferns caught at my father's hair, and he kept tripping over roots and rotten logs.",
          "Sometimes the trees were clumped so closely together that he couldn't squeeze between them and had to walk a long way around.",
          "He began to hear whispery noises, but he couldn't see any animals anywhere.",
          "The deeper into the jungle he went the surer he was that something was following him, and then he thought he heard whispery noises on both sides of him as well as behind.",
          "He tried to run, but he tripped over more roots, and the noises only came nearer.",
          "Once or twice he thought he heard something laughing at him.",
          "At last he came out into a clearing and ran right into the middle of it so that he could see anything that might try to attack him.",
          "He was surprised when he looked and saw fourteen green eyes coming out of the jungle all around the clearing, and when the green eyes turned into seven tigers! The tigers walked around him in a big circle, looking hungrier all the time, and then they sat down and began to talk.",
          "\"I suppose you thought we didn't know you were trespassing in our jungle!\"",
          "\"Did you know that not one explorer has ever left this island alive?\" said the third tiger.",
          "Then the next tiger spoke.",
          "\"I suppose you're going to say you didn't know it was our jungle!\"",
          "The tigers went on talking in turn.",
          "\"You're our first little boy, you know.\"",
          "\"I'm curious to know if you're especially tender.\"",
          "\"Maybe you think we have regular meal-times, but we don't.\"",
          "\"We just eat whenever we're feeling hungry,\" said the fifth tiger.",
          "\"And we're very hungry right now.\"",
          "\"In fact, I can hardly wait,\" said the sixth.",
          "\"I can't wait!\" said the seventh tiger.",
          "And then all the tigers said together in a loud roar, \"Let's begin right now!\" and they moved in closer.",
          "My father looked at those seven hungry tigers, and then he had an idea.",
          "He quickly opened his knapsack and took out the chewing gum.",
          "He had heard that tigers were especially fond of chewing gum, which was very scarce in the jungle.",
          "So he threw them each a piece but they only growled, \"As fond as we are of chewing gum, we're sure we'd like you even better!\" and they moved so close that he could feel them breathing on his face.",
          "\"But this is very special chewing gum,\" said my father.",
          "\"If you keep on chewing it long enough it will turn green, and then if you plant it, it will grow more chewing gum, and the sooner you start chewing the sooner you'll have more.\"",
          "The tigers said, \"Why, you don't say! Isn't that fine!\"",
          "And as each one wanted to be the first to plant the chewing gum, they all unwrapped their pieces and began chewing as hard as they could.",
          "Every once in a while one tiger would look into another's mouth and say, \"Nope, it's not done yet,\" until finally they were all so busy looking into each other's mouths to make sure that no one was getting ahead that they forgot all about my father.",
          "And so, my father, the little boy, slipped away down the trail and left the tigers behind."
        ]
      }
    ],
    "questions": [
      {
        "text": "In the story, the tigers liked ____.",
        "distractors": [
          "drinking water",
          "chewing gum",
          "telling jokes"
        ],
        "correct": "chewing gum"
      },
      {
        "text": "Father escaped when the tigers got ____.",
        "distractors": [
          "busy",
          "tired",
          "angry"
        ],
        "correct": "busy"
      }
    ]
  },
  {
    "grade": "3",
    "author": " ",
    "title": "The Life Cycle of Butterflies",
    "storyid": "93405360-362f-11e9-bb3b-e7e2c0de6bee",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "There are four separate stages in the life of a butterfly.",
          "The egg is a tiny, round or oval shape that gets attached by the female butterfly to a leaf, stem or other object.",
          "The egg is usually attached near the intended caterpillar food.",
          "The caterpillar or larva is the long, worm like state of the butterfly.",
          "It sometimes has an interesting pattern of stripes or patches.",
          "It might have hairs like spines.",
          "This is the feeding and the growth stage of the butterfly.",
          "As the caterpillar grows, it sheds its skin four or more times so it can enclose its rapidly growing body.",
          "The pupa is the transformation stage.",
          "The caterpillar tissues are broken down to form the adult insect structures.",
          "Usually the pupa is brown or green color to blend into the surroundings.",
          "Many times the butterfly will remain in this stage over winter.",
          "A butterfly in this state is sometimes called a chrysalis.",
          "The adult or imago is the colorful butterfly that you see throughout the warmer months of spring and summer.",
          "The adult stage is called the reproductive stage.",
          "Adults find mates and lay more eggs.",
          "The adult stage also migrates or colonizes new places to live."
        ]
      }
    ],
    "questions": [
      {
        "text": "There are ____ stages in a butterfly's life.",
        "distractors": [
          "two",
          "three",
          "four"
        ],
        "correct": "four"
      },
      {
        "text": "A Pupa's colors help it to ____.",
        "distractors": [
          "mate",
          "blend in",
          "transform"
        ],
        "correct": "blend in"
      }
    ]
  },
  {
    "grade": "3",
    "author": " ",
    "title": "The Day My Father Met A Rhino",
    "storyid": "3768f3c0-7325-11e9-b491-3358089dfb6b",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "Long ago, my father, who was then a little boy, was lost in the jungle.",
          "He felt really lucky when he found a trail.",
          "All sorts of animals might be using that trail.",
          "But my father decided to follow the clear path in hopes of finding a way back home.",
          "He kept a sharp lookout in front and behind and went on.",
          "Just as he was feeling a little safe, he came around a curve right behind two wild boars.",
          "One of them was saying to the other, \"Did you know that Turtle said he saw Monkey walking by the river last night?\"",
          "\"But, Monkey said he was in the trees asleep.\"",
          "\"I told you that there was a human about,\" said the other boar, \"and I intend to find him out.",
          "\"I simply can't stand people.\"",
          "\"Me neither,\" said a tiny little voice, and my father knew that a mouse was there, too.",
          "\"Well,\" said the first boar, \"you search the trail up this way.\"",
          "\"I'll go back down the other way through the big clearing, and we'll send Mouse to watch the Rocks.\"",
          "My father hid behind a mahogany tree just in time, and the first boar walked right past him.",
          "My father waited for the other boar to get a head start on him.",
          "Soon the trail crossed a little brook and my father, who by this time was very thirsty, stopped to get a drink of water.",
          "He had on his rubber boots, so he waded into a little pool of water and was stooping down when something quite sharp picked him up by the seat of the pants and shook him very hard.",
          "\"Don't you know that's my private weeping pool?\" said a deep angry voice.",
          "My father couldn't see who was talking because he was hanging in the air right over the pool, but he said, \"Oh, no, I'm so sorry.\"",
          "\"I didn't know that everybody had a private weeping pool.\"",
          "\"Everybody doesn't!\" said the angry voice, \"but I do because I have such a big thing to weep about, and I drown everybody I find using my weeping pool.\"",
          "With that the animal tossed my father up and down over the water.",
          "\"What is it that you weep about so much?\" asked my father, trying to get his breath, and he thought over all the things he had in his pack.",
          "\"Oh, I have many things to weep about, but the biggest thing is the color of my tusk.\"",
          "My father squirmed every which way trying to see the tusk, but it was through the seat of his pants where he couldn't possibly see it.",
          "\"When I was a young rhinoceros, my tusk was pearly white,\" said the animal (and then my father knew that he was hanging by the seat of his pants from a rhinoceros' tusk!), \"but it has turned a nasty yellow gray in my old age, and I find it very ugly.",
          "\"You see, everything else about me is ugly, but when I had a beautiful tusk I didn't worry so much about the rest.\"",
          "\"Now that my tusk is ugly too, I can't sleep nights just thinking about how completely ugly I am, and I weep all the time.\"",
          "\"But why should I be telling you these things?\"",
          "\"I caught you using my pool and now I'm going to drown you.\"",
          "\"Wait a minute, Rhinoceros,\" said my father.",
          "\"I have some things that will make your tusk all white and beautiful again.\"",
          "\"Just let me down and I'll give them to you.\"",
          "The rhinoceros said, \"You do? I can hardly believe it! Why, I'm so excited!\"",
          "He put my father down and danced around in a circle while my father got out a tube of tooth paste and his toothbrush.",
          "\"Now,\" said my father, \"just move your tusk a little nearer, please, and I'll show you how to begin.",
          "My father wet the brush in the pool, squeezed on a dab of tooth paste, and scrubbed very hard in one tiny spot.",
          "Then he told the rhinoceros to wash it off, and when the pool was calm again, he told the rhinoceros to look in the water and see how white the little spot was.",
          "It was hard to see in the dim light of the jungle, but sure enough, the spot shone pearly white, just like new.",
          "The rhinoceros was so pleased that he grabbed the toothbrush and began scrubbing violently, forgetting all about my father.",
          "Just then my father heard hoofs and he jumped behind the rhino.",
          "It was the boar coming back from the big clearing.",
          "The boar looked at the rhinoceros, and at the toothbrush, and at the tube of tooth paste, and then he scratched his ear on a tree.",
          "\"Tell me, Rhinoceros,\" he said, \"where did you get that fine tube of tooth paste and that toothbrush?\"",
          "\"Too busy!\" said the rhinoceros, and he went on brushing as hard as he could.",
          "The boar sniffed angrily and trotted down the trail, muttering to himself, \"Very suspicious, don't like it one bit, not one bit!\"",
          "And, that's when my father made his escape and continued down the path."
        ]
      }
    ],
    "questions": [
      {
        "text": "The ____ of his tusk made the Rhino sad.",
        "distractors": [
          "color",
          "size",
          "age"
        ],
        "correct": "color"
      },
      {
        "text": "Father ____ by giving Rhino toothpaste.",
        "distractors": [
          "gets in trouble",
          "escapes",
          "fools the boar"
        ],
        "correct": "escapes"
      }
    ]
  },
  {
    "grade": "3",
    "author": " ",
    "title": "Lakes and Streams",
    "storyid": "38bcabb0-725b-11e9-9048-67e3d3231e74",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "The lakes and streams of Texas are home to many animals.",
          "Many kinds of fish live in the lakes and streams.",
          "Bass and sunfish eat other fish and the insects in the water.",
          "People enjoy fishing for bass and sunfish.",
          "Catfish and carp swim along the bottom and look for food.",
          "Turtles and frogs live in the lakes and streams, but they breathe the air.",
          "On warm days, turtles like to crawl out of the water and lie in the sun.",
          "Frogs like to hop out of the water at night and croak.",
          "Crawfish and minnows spend much of their time hiding from big fish.",
          "Many birds and mammals live around lakes and rivers.",
          "They use the river for drinking water and as a place to find things to eat."
        ]
      }
    ],
    "questions": [
      {
        "text": "Crawfish have to ___ from big fish.",
        "distractors": [
          "run away",
          "hide",
          "take food"
        ],
        "correct": "hide"
      },
      {
        "text": "Lakes and streams provide ____ many kinds of animals.",
        "distractors": [
          "air for",
          "transportation for",
          "home for"
        ],
        "correct": "home for"
      }
    ]
  },
  {
    "grade": "3",
    "author": " ",
    "title": "Michelangelo",
    "storyid": "e5800670-7117-11e9-84af-87f1ff3e5777",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "Michelangelo was a great artist.",
          "He was born in Italy in 1475.",
          "He grew up in the country.",
          "The country was rich in stone.",
          "Stonecutters were all around him.",
          "The young boy loved to draw and paint.",
          "At the age of thirteen, his father sent him to study art.",
          "Soon, he became better than his teacher.",
          "The ruler of a big city sent a message to his teacher.",
          "'Send me your best student,' he wrote.",
          "Michelangelo went to live with the ruler, who lived in a palace.",
          "The palace had a beautiful sculpture garden.",
          "Michelangelo loved the sculptures in the garden.",
          "It was there that he was inspired.",
          "He began to carve many pieces of marble.",
          "This great artist lived to be almost ninety years old.",
          "He created some of the most beautiful pieces of art that the world has ever seen."
        ]
      }
    ],
    "questions": [
      {
        "text": "Michelangelo was a ____.",
        "distractors": [
          "sculptor",
          "stonecutter",
          "ruler"
        ],
        "correct": "sculptor"
      },
      {
        "text": "He was inspired to be a great artist by a ____.",
        "distractors": [
          "garden",
          "teacher",
          "ruler"
        ],
        "correct": "garden"
      }
    ]
  },
  {
    "grade": "3",
    "author": " ",
    "title": "Tigers",
    "storyid": "528602b0-725d-11e9-9048-67e3d3231e74",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "The speed and agility give the tiger the title of the world's top predator over the larger but slower grizzly bear.",
          "A well rounded athlete, the tiger can climb, swim, leap great distances and pull five times the force of a strong human.",
          "The tiger is the largest and most powerful cat.",
          "The tiger is in the same group as lions, leopards, and jaguars.",
          "Those four cats are the only ones who can roar.",
          "Where do tigers live?",
          "They live in forests and grasslands of eastern and southeastern Asia.",
          "Tigers live in countries such as Bangladesh, China, India, and eastern Russia.",
          "The Bengal Tiger is the national animal of India.",
          "What do tigers look like?",
          "Tigers are reddish orange with very bold black stripes and areas of white on the chest, neck and inside of the legs.",
          "Their stripes help them camouflage into the trees and shrubs keeps them from being seen by other animals.",
          "Tigers are enormous, with bodies six to nine feet long.",
          "Their tails are often three feet long.",
          "An adult tiger weights as much as three humans.",
          "Tiger teeth and jaws are massively and fantastically strong.",
          "Their paws are heavily padded.",
          "What do tigers eat, and how do they catch their prey?",
          "Tigers mostly eat herbivores, like elk, deer, wild pigs, and buffalo.",
          "Like most other cats, they are solitary hunters.",
          "Tigers often hide close to the ground and wait patiently for the perfect moment to ambush their prey.",
          "People avoid tiger attacks by wearing a face mask on the back of their heads.",
          "Tigers think twice about pouncing when they can see a face, since they usually attack from behind.",
          "How do tigers raise their young?",
          "Tigers have an average of two to three cubs per litter.",
          "After eight weeks of age the cubs begin to join the mother for hunting.",
          "They usually have learned how to successfully kill prey by the age of six months.",
          "But, tiger cubs are not ready to hunt independently until nearly two years old.",
          "The father plays no role in bringing up the babies, though there are occasionally reports of male tigers socializing with their mates and cubs outside the breeding season.",
          "Tigers are striped through and through.",
          "If you were to shave a tiger, you would see the stripes tattooed on the skin beneath their fur.",
          "Note, please do not try this at home."
        ]
      }
    ],
    "questions": [
      {
        "text": "Animals that eat ____ are herbivores.",
        "distractors": [
          "other animals",
          "plants",
          "insects"
        ],
        "correct": "plants"
      },
      {
        "text": "The ____ of the story is that tigers are highly skilled hunters.",
        "distractors": [
          "main point",
          "least important point",
          "only point"
        ],
        "correct": "main point"
      }
    ]
  },
  {
    "grade": "3",
    "author": " ",
    "title": "Robins",
    "storyid": "75254d00-725b-11e9-9048-67e3d3231e74",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "Have you ever seen a robin hopping around on the grass looking for bugs?",
          "Seeing a robin tells us that spring is on its way.",
          "A robin lays eggs in a nest made of twigs and grass.",
          "The eggs are blue.",
          "The mother robin sits on the eggs to keep them warm.",
          "When the baby birds hatch, they have no feathers.",
          "The mother robin leaves the nest to find food for them.",
          "She feeds them bugs and worms.",
          "The babies open their mouths wide so they can be fed.",
          "After some time the babies get bigger and grow feathers.",
          "They still live in the nest, and the mother still feeds them.",
          "The baby robins soon have enough feathers to practice flying.",
          "They flap their wings as they stand in the nest.",
          "Finally they are ready to practice flying.",
          "The baby robins learn quickly.",
          "They practice flying with their mother.",
          "The mother robin also takes them hunting for food.",
          "They have very good hearing and can hear the worms underground.",
          "The baby robins are all grown up now, and look like their mother.",
          "The baby robins are finally ready to take care of themselves.",
          "Soon they, too, will have babies of their own."
        ]
      }
    ],
    "questions": [
      {
        "text": "Robin babies ____ their mothers.",
        "distractors": [
          "don't need",
          "look like",
          "learn from"
        ],
        "correct": "learn from"
      },
      {
        "text": "Baby robins ____ flying.",
        "distractors": [
          "must practice",
          "are good at",
          "reject"
        ],
        "correct": "must practice"
      }
    ]
  },
  {
    "grade": "3",
    "author": " ",
    "title": "Trees",
    "storyid": "4e52ca50-5fc7-11e9-afeb-97aa28d47c59",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "Trees come in unusual shapes and sizes.",
          "They grow in different climates, like in the mountains and the deserts.",
          "Some trees are very small and kept inside homes.",
          "Other trees, like redwoods, are so big that cars can drive through holes cut in the tree trunks.",
          "Some trees grow very tall and need lots of water.",
          "These types of trees usually grow in swamps or by rivers.",
          "Other trees grow in very dry climates.",
          "These trees have very small and thin leaves that grow on branches with thorns.",
          "Some trees, like pine trees, grow in very cold places and keep their pine needles year round.",
          "Cottonwood trees grow in the middle latitudes and lose their leaves when the weather gets cool.",
          "There are many kinds of trees."
        ]
      }
    ],
    "questions": []
  },
  {
    "grade": "3",
    "author": " ",
    "title": "Prism Palace",
    "storyid": "3cfc9580-707d-11e9-8e43-85a5c4ae9456",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "Tess walked over to the crystal prism and looked at it with curiosity.",
          "At her birthday party, her mother explained that prisms split light into the colors of the rainbow.",
          "'I wonder how it separates light?' thought Tess.",
          "Just then a fairy darted out of the middle of the prism onto the window sill.",
          "Her dress sparkled with pastel colors.",
          "'Who are you?' exclaimed Tess.",
          "'Hello, my name is Tara,' said the fairy.",
          "'Do you want to explore Prism Palace and go inside the prism?', invited the fairy in her high, squeaky, little voice.",
          "Tess, too excited to utter words, nodded very hard.",
          "'But, on second thought, maybe I am too large', said Tess disappointedly.",
          "'I can fix that with my magic,' the fairy said confidently.",
          "'Just touch my hand with your finger and I will make you very small.'",
          "Tess reached out and suddenly she was quite tiny.",
          "'Now that you are miniature, come inside my palace of light,' said the fairy as she pulled on a crystal door knob.",
          "The hallway inside was enormous and blazing with lights of every color.",
          "Tara showed her down the hallway to a corner wall of crystal glass.",
          "Standing on the glass floor, Tess could look through the glass ceiling or through the glass wall.",
          "'This is the best place to explain where the different colors come from', said Tara.",
          "'The light from the sun comes through the prism one way, like the ceiling, and goes out another way, like the wall.'",
          "'The light has to bend to get out again and when it bends the colors split off because they have different sized wavelengths.'",
          "'Colors do not have sizes!', Tess protested.",
          "'Sure they do,' explained Tara.",
          "'Colors are waves of light.'",
          "'Each color is a different kind of light that has its own wave length.'",
          "'Red is a very long wave and violet is a short wave.'",
          "'The others are in between.'",
          "'That's hard to believe,' Tess countered.",
          "'What if I show you light rays?', Tara offered. 'We can go ray skating.'",
          "Tess tilted her head. 'What do you mean?'",
          "'We put on special rainbow skates and glide on a ray of colored light,' Tara explained.",
          "So, Tess pulled on the skates and asked, 'Which color should we glide on?'",
          "'Well, what is your favorite color?', responded Tara.",
          "'Red, especially now that I know it is the color with the longest waves', replied Tess.",
          "As soon as they stepped onto a red ray everything they saw turned red.",
          "Tess was red.",
          "Tara was red.",
          "Tara leaped down the narrow ray and began skating beautifully.",
          "But, Tess was scared.",
          "She did not like falling and the red ray looked slippery.",
          "So, she stood still as a statue.",
          "'Why aren't you skating?' a voice asked behind her.",
          "Tess turned in surprise.",
          "She saw a red haired elf in a rainbow colored cap and socks.",
          "'My name is Roy G Biv,' he said.",
          "'Pleased to meet you.' He took off his cap and bowed.",
          "His enormous ears wiggled.",
          "'I'm Tess,' Tess said as her lips quivered.",
          "'You have an interesting name,' offered Tess.",
          "'Each letter in my name stands for one of the colors of light – Red, Orange, Yellow, Green, Blue, Indigo and Violet', explained Roy.",
          "'Do you want to skate on light like Tara?' asked Roy.",
          "'Yes,' she said and her face brightened with a smile.",
          "'I'll show you how and hold your hand', offered Roy.",
          "Roy pulled on his skates, jumped past Tess and held out his hand for her.",
          "Roy said, 'Look out across the ray.'",
          "'Feel your body balance on your skates.'",
          "'We will go slowly until you know you can do it.'",
          "Tess smiled at Roy as she balanced and slid along the ray.",
          "The red everywhere was so beautiful, she forgot to be afraid.",
          "Tess skated a long distance down the ray holding Roy's hand.",
          "She noticed an apple tree, then a red clay house and next to it a barn, with two cardinals eating berries.",
          "Of course, everything was red.",
          "They were in the Land of Red.",
          "'Look at the rose garden, right up ahead', said Roy and let go of her hand to point down the ray.",
          "Tess was so surprised by the red roses stretching as far as she could see, that she jerked backward and lost her balance.",
          "She tipped over the edge of the ray, waving her arms wildly, trying to stop herself from falling, but she could not stop herself.",
          "Tess fell toward the ground.",
          "She started to scream, but stopped when she felt Tara's arms under her.",
          "Tara flew Tess up into the air and then flew back to where Roy stood.",
          "'I've got to go back to my regular size now', said Tess.",
          "She was still shaky from the fall.",
          "Tara touched her hand and Tess quickly returned to her normal size, standing by her window, the prism in her hand.",
          "'Thank you for showing me how a prism splits light', Tess exclaimed.",
          "'Come back soon,' shouted Roy and Tara together from inside the prism."
        ]
      }
    ],
    "questions": [
      {
        "text": "A prism ____ light.",
        "distractors": [
          "separates",
          "reflects",
          "enhances"
        ],
        "correct": "separates"
      },
      {
        "text": "Roy gets his name from ____.",
        "distractors": [
          "Tess",
          "the colors of the spectrum",
          "the red ray"
        ],
        "correct": "the colors of the spectrum"
      }
    ]
  },
  {
    "grade": "2",
    "author": " ",
    "title": "Sherlock",
    "storyid": "340d86d0-707f-11e9-8e43-85a5c4ae9456",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "'Hi, I'm Sherlock the cat' 'Do you need some help?' Katie asks Sherlock.",
          "Sherlock looks this way and that way.",
          "He looks up and down and all around.",
          "'I'm just a little lost,' he says.",
          "Katie says, 'The mystery of the lost kitten! I will take your case.",
          "' Katie writes down the clues.",
          "Someone has trimmed Sherlock's nails.",
          "His coat is brushed and cared for.",
          "The kitten fur around his neck is pushed down.",
          "'Someone has been taking good care of you.",
          "' Katie goes on, 'You had a collar on.",
          "' 'Yes, if only we could find my collar,' says Sherlock.",
          "'I have an idea,' Katie replies.",
          "'We need to find anyone who saw you wearing your collar.",
          "' Sherlock says, 'Like witnesses?' Katie and Sherlock look for a witness.",
          "Soon, lunch time comes.",
          "'We have tuna fish.",
          "Are you hungry, Sherlock?', asks Katie.",
          "As they eat at Katie's house, she asks Sherlock to tell her everything he noticed that morning.",
          "'Blue sky, brown stones, yellow feathers and green trees,' says Sherlock.",
          "Katie hears a peck at the window.",
          "'Those are the yellow feathers,', says Sherlock.",
          "'Hi, bird,' says Katie.",
          "'Did you see this cat this morning?'",
          "'Yes, I saw the kitten lose his collar,' the bird said.",
          "'Where?' asks Katie.",
          "'Look for a pile of stones,' and the bird flew away.",
          "Katie has that look on her face.",
          "The look that means her big brain is hard at work.",
          "Sherlock follows her as she heads back to the park.",
          "'We solved your mystery,' Katie says.",
          "'I know where you live.'",
          "'Where?' says Sherlock.",
          "'Here is the pile of stone that bird told us about and look, here is your collar with your house address on it.'",
          "'What a relief,' Sherlock sighs.",
          "'Now I can go home and get some milk.'",
          "But, Katie is not ready to say goodbye.",
          "'I have an idea, Sherlock.'",
          "'Will you be my partner and help me solve mysteries?'",
          "'Yes, Katie, as long as we have tuna fish for lunch every day,' says Sherlock."
        ]
      }
    ],
    "questions": [
      {
        "text": "The mystery cleared up when ____ provided the clue.",
        "distractors": [
          "Sherlock",
          "the bird",
          "Katie"
        ],
        "correct": "the bird"
      },
      {
        "text": "Sherlock is mainly interested in ____.",
        "distractors": [
          "getting his collar back.",
          "getting home",
          "eating tuna fish"
        ],
        "correct": "eating tuna fish"
      }
    ]
  },
  {
    "grade": "2",
    "author": " ",
    "title": "Are Bats Birds?",
    "storyid": "b97a3300-7259-11e9-9048-67e3d3231e74",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "Are bats birds?",
          "No, bats are mammals with wings.",
          "In fact, bats are the only mammals that can truly fly.",
          "Bats have two wide wings that have a web of double skin stretched over the bones of their long arms.",
          "The skin is thinner than a plastic bag.",
          "Their wings are joined to the sides of their bodies and to their back legs and tails.",
          "The body of the bat is covered with fur.",
          "They lick it to keep it clean and comb it with their claws.",
          "Bats spend most of their time in the air.",
          "They are fantastic flyers.",
          "Bats can rise and dive and change direction instantly.",
          "Bats also crawl on the ground.",
          "They use their tails to help them climb.",
          "Bats do not make nests.",
          "When bats want to sleep, they fold their wings around themselves and hang upside down.",
          "Female bats even give birth while hanging upside down.",
          "Usually only one bat is born each year.",
          "The baby bat clings to its mother's fur with its teeth and claws.",
          "The mother feeds it with her milk.",
          "When the baby bat is two weeks old, it can hang upside down by its feet.",
          "Then, the mother can hunt without the baby.",
          "When the baby bat is two months old, it can fly by itself.",
          "Bats sleep during the day and hunt at night.",
          "Bats are very helpful to man because they eat so many insects each night.",
          "Bats are very different from birds."
        ]
      }
    ],
    "questions": [
      {
        "text": "The only ___ mammal is the bat.",
        "distractors": [
          "flying",
          "nesting",
          "night hunting"
        ],
        "correct": "flying"
      },
      {
        "text": "Bat wings are ____.",
        "distractors": [
          "not very wide",
          "very thin",
          "covered with fur"
        ],
        "correct": "very thin"
      }
    ]
  },
  {
    "grade": "2",
    "author": " ",
    "title": "Buster Bear Goes Fishing",
    "storyid": "9055c650-7327-11e9-b491-3358089dfb6b",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "Buster Bear yawned as he lay on his comfortable bed of leaves and watched the first early morning sunbeams creeping through the Green Forest to chase out the Black Shadows.",
          "Once more he yawned, and slowly got to his feet and shook himself.",
          "Then he walked over to a big pine tree, stood up on his hind legs, reached as high up on the trunk of the tree as he could, and scratched the bark with his great claws.",
          "After that he yawned until it seemed as if his jaws would crack, and then sat down to think what he wanted for breakfast.",
          "While he sat there, trying to make up his mind what would taste best, he was listening to the sounds that told of the waking of all the little people who live in the Green Forest.",
          "He heard Sammy Jay way off in the distance screaming, \"Thief! Thief!\" and grinned.",
          "\"I wonder,\" thought Buster, \"if someone has stolen Sammy's breakfast, or if he has stolen the breakfast of someone else.",
          "\"Probably he is the thief himself.\"",
          "He heard Red Squirrel scolding as fast as he could make his tongue go and working himself into a terrible rage.",
          "\"Must be that Squirrel got out of bed the wrong way this morning,\" thought he.",
          "He heard Blake the Crow cawing at the top of his lungs, and he knew by the sound that Blake was getting into mischief of some kind.",
          "He heard the sweet voices of happy little singers, and they were good to hear.",
          "But most of all he listened to a merry, low, silvery laugh that never stopped but went on and on, until he just felt as if he must laugh too.",
          "It was the voice of the Laughing Brook.",
          "And as Buster listened it suddenly came to him just what he wanted for breakfast.",
          "\"I'm going fishing,\" said he in his deep grumbly rumbly voice to no one in particular.",
          "\"Yes, Sir, I'm going fishing.\"",
          "\"I want some fat trout for my breakfast.\"",
          "He shuffled along over to the Laughing Brook, and straight to a little pool of which he knew, and as he drew near he took the greatest care not to make even a tiny bit of noise.",
          "Now it just happened that early as he was, someone was before Buster Bear.",
          "When he came in sight of the little pool, who should he see but another fisherman there, who had already caught a fine fat trout.",
          "Who was it?",
          "Why, Little Joe Otter to be sure.",
          "He was just climbing up the bank with the fat trout in his mouth.",
          "Buster Bear's own mouth watered as he saw it.",
          "Little Joe sat down on the bank and prepared to enjoy his breakfast.",
          "He hadn't seen Buster Bear, and he didn't know that anyone else was anywhere near.",
          "Buster Bear tiptoed up very softly until he was right behind Little Joe Otter.",
          "\"Woof, woof!\" said he in his deepest, most grumbly rumbly voice.",
          "\"That's a very fine looking trout.\"",
          "\"I wouldn't mind if I had it myself.\"",
          "Little Joe Otter gave a frightened squeal and without even turning to see who was speaking dropped his fish and dived headfirst into the Laughing Brook.",
          "Buster Bear sprang forward and with one of his big paws caught the fat trout just as it was slipping back into the water.",
          "\"Here's your trout, Mr. Otter,\" said he, as Little Joe put his head out of water to see who had frightened him so.",
          "\"Come and get it.\"",
          "But Little Joe wouldn't.",
          "The fact is, he was afraid to.",
          "He snarled at Buster Bear and called him a thief and everything bad he could think of.",
          "Buster didn't seem to mind.",
          "He chuckled as if he thought it all a great joke and repeated his invitation to Little Joe to come and get his fish.",
          "But Little Joe just turned his back and went off down the Laughing Brook in a great rage.",
          "\"It's too bad to waste such a fine fish,\" said Buster thoughtfully.",
          "\"I wonder what I'd better do with it.\"",
          "And while he was wondering, he ate it all up.",
          "Then he started down the Laughing Brook to try to catch some for himself."
        ]
      }
    ],
    "questions": [
      {
        "text": "Joe Otter and Buster both like ____.",
        "distractors": [
          "trout",
          "berries",
          "crow"
        ],
        "correct": "trout"
      },
      {
        "text": "Buster ____ Joe into dropping the fish",
        "distractors": [
          "bullies",
          "talks",
          "scares"
        ],
        "correct": "scares"
      }
    ]
  },
  {
    "grade": "2",
    "author": " ",
    "title": "Great Cake Contest",
    "storyid": "62d4f900-7424-11e9-bc59-ab06df4fe462",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "Lucky loves cake.",
          "He is so happy that the Great Cake Contest is in town.",
          "\"I know, I can make a pancake!\" shouts Lucky.",
          "He walks to Pam's house to share his idea, but she already beat him to it.",
          "\"Or, what if I made a carrot cake?\" he wonders.",
          "He goes to tell Nina his plan, but she had the same idea.",
          "\"What about baking a black forest cake?\"",
          "He rushes to tell Kim what he's come up with, but he's too late.",
          "On the way to Nora's house, he thinks: \"Let me just make a Christmas cake!\"",
          "But Nora already made that happen.",
          "\"What other cake can I bake?\" he asks himself.",
          "\"How about a chocolate cake?\"",
          "He arrives at Linda's house but he was too slow.",
          "Lucky gets an idea.",
          "\"I will make an apple cake.\"",
          "He gets to Zola's house but she's way ahead of him.",
          "Lucky feels sad when he gets home because he is out of ideas.",
          "He asks his family to help him think about what great cake he can bake.",
          "And they suggest a giant cake.",
          "Lucky begins to bake and bake.",
          "The cake is so big, so wide, so tall that it begins to wobble, wobble, wobble and fall!",
          "Oh no! Everyone at the Great Cake Contest is covered in cake.",
          "Where are the judges?",
          "Where are the contestants?",
          "Where is Lucky?",
          "The judges munch and chomp their way out and everyone agrees: Lucky is the winner of the Great Cake Contest!"
        ]
      }
    ],
    "questions": [
      {
        "text": "Lucky has a hard time ____ idea for a cake.",
        "distractors": [
          "stealing an",
          "finding a new",
          "thinking of an"
        ],
        "correct": "finding a new"
      },
      {
        "text": "Lucky ends up making a ____ cake.",
        "distractors": [
          "chocolate",
          "apple",
          "giant"
        ],
        "correct": "giant"
      }
    ]
  },
  {
    "grade": "2",
    "author": " ",
    "title": "How to Make a Telephone",
    "storyid": "42758f10-5586-11e9-b3e5-f17a2d74382b",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "Did you know that you can make a telephone that really works?",
          "It is very simple and a lot of fun.",
          "All the things you need are in the kitchen.",
          "Ask your mom, dad or older brother or sister to help you.",
          "First, you need to get two tin cans.",
          "Wash them in warm water with soap and then dry them.",
          "Put some tape around the rim of each can.",
          "This will keep you from being cut by the can.",
          "Punch a hole in the center of the bottom of each can.",
          "A hammer and nail will do the job.",
          "Be sure to ask a grown-up to do this for you.",
          "Then cut some string.",
          "It can be as long as you like.",
          "Tie a knot at one end of the string and put the string through the can.",
          "The knot should be on the inside of the can.",
          "Then put the string through the other can.",
          "Tie a knot at the other end of the string.",
          "Now you are ready to talk to your friends with your new telephone.",
          "Ask your friends to hold the can next to their ears.",
          "Walk far away, so that the string is pulled tightly.",
          "Begin talking to your friends and having fun."
        ]
      }
    ],
    "questions": [
      {
        "text": "The ____ connects the two ends of the telephone.",
        "distractors": [
          "string",
          "can",
          "knots"
        ],
        "correct": "string"
      },
      {
        "text": "The ____ are like phones and the string is like telephone wire.",
        "distractors": [
          "knots",
          "nails",
          "tin cans"
        ],
        "correct": "tin cans"
      }
    ]
  },
  {
    "grade": "2",
    "author": " ",
    "title": "Super Animals",
    "storyid": "69e6cbd0-7328-11e9-b491-3358089dfb6b",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "There are five senses that both humans and many animals have.",
          "But some animals have one sense that is super sharp.",
          "Chameleons have super sight.",
          "They can move their two eyes separately from each other.",
          "Chameleons can look two ways at the same time.",
          "Catfish have super taste.",
          "Humans have taste buds on our tongues.",
          "Catfish have taste buds all over their bodies.",
          "Catfish are like swimming tongues!",
          "Red foxes have super hearing.",
          "They can hear mice squeaking under the snow from very far away.",
          "The red fox's super hearing helps it catch dinner in the wintertime!",
          "Spiders have a super sense of touch.",
          "They can feel tiny movements on a spider web.",
          "Spiders feel things by the hairs that cover their legs.",
          "Dogs have super smell.",
          "They can smell things that are farther away than we can see.",
          "Some dogs can smell something that is buried underground.",
          "Dogs are very good at smelling their owner too."
        ]
      }
    ],
    "questions": [
      {
        "text": "____ is the super sense of chameleons.",
        "distractors": [
          "Sight",
          "Taste",
          "Hearing"
        ],
        "correct": "Sight"
      },
      {
        "text": "Dogs have super smell and catfish have super ____.",
        "distractors": [
          "sight",
          "taste",
          "hearing"
        ],
        "correct": "taste"
      }
    ]
  },
  {
    "grade": "2",
    "author": " ",
    "title": "Tree Homes",
    "storyid": "3c396bd0-725a-11e9-9048-67e3d3231e74",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "Have you ever seen a hole in a tree and wondered if some animal lives there?",
          "If you look closely, you may see a redheaded woodpecker.",
          "These birds have long, sharp beaks.",
          "They build nests by pecking holes in trees.",
          "It is there that they have their babies.",
          "This keeps them safe, high off of the ground.",
          "If you look inside a hole in a tree, you may find a black and white masked animal with white whiskers looking back at you.",
          "Raccoons often move into hollow trees.",
          "They use their sharp claws to climb up the tree.",
          "Their paws are strong, so getting into the hole is easy.",
          "A pine marten also lives in a hole of a tree.",
          "It looks like a brown raccoon with no mask.",
          "It is about as big as a small house cat.",
          "The pine marten often moves into the woodpecker's nest when the woodpecker moves out.",
          "Many other animals live in holes in trees.",
          "This includes squirrels, some types of frogs, and some types of owls."
        ]
      }
    ],
    "questions": [
      {
        "text": "____ make their homes in trees.",
        "distractors": [
          "Pine martens",
          "House cats",
          "Robins"
        ],
        "correct": "Pine martens"
      },
      {
        "text": "Based on the story, ____ animals live in trees.",
        "distractors": [
          "a few",
          "nesting",
          "many kinds of"
        ],
        "correct": "many kinds of"
      }
    ]
  },
  {
    "grade": "2",
    "author": " ",
    "title": "Dance, Mia",
    "storyid": "df7e6230-7423-11e9-bc59-ab06df4fe462",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "It is almost time for the big concert of school.",
          "All the children are having fun practicing.",
          "But not Mia.",
          "She is worried she will forget her dance steps.",
          "\"I'll help you practice at home.\"",
          "\"I wish this concert would never happen!\"",
          "Not a chance!",
          "The day of the concert is getting closer.",
          "\"Granny has sent you a gift.\"",
          "Mia is too worried about the concert to open gifts.",
          "Perhaps she should take a look inside.",
          "So she does.",
          "Look, what great dancing shoes from Granny.",
          "Granny was the best dancer ever.",
          "Now Mia practices every day after school.",
          "And she dances in her dreams.",
          "Mia must rest.",
          "The big concert is tomorrow.",
          "It's concert day.",
          "Mia does her dance just right.",
          "What great fun!",
          "And surprise!",
          "Granny has even come to watch Mia dance.",
          "\"You were amazing! You are the best dancer I've ever seen.\""
        ]
      }
    ],
    "questions": [
      {
        "text": "Mia gets ____ from Granny.",
        "distractors": [
          "a dress",
          "shoes",
          "advice"
        ],
        "correct": "shoes"
      },
      {
        "text": "Lots of ____ helps Mia dance well.",
        "distractors": [
          "food",
          "children",
          "practice"
        ],
        "correct": "practice"
      }
    ]
  },
  {
    "grade": "2",
    "author": " ",
    "title": "Little Hawk",
    "storyid": "8fb5cbf0-725a-11e9-9048-67e3d3231e74",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "Little Hawk went to bed early and soon fell asleep.",
          "ROAR! Little Hawk sat straight up when he heard that noise.",
          "He was frightened and called out for his father, who was fast asleep on the big bear rug.",
          "Another loud noise made Little Hawk jump, and a flash of light surprised him.",
          "\"What kind of animal is this?\" thought Little Hawk.",
          "\"It roars loudly and spits fire.\"",
          "Again, he tried to wake his father.",
          "\"I am eight winters old, and I can take care of myself!\" Little Hawk thought.",
          "\"I will go and fight this animal, and Father will be proud of me!\"",
          "Little Hawk crept outside with his bow and arrows, and followed the path up the mountain. ROAR!",
          "\"Little Hawk, Little Hawk, where are you?\" Father yelled.",
          "Little Hawk was happy to see his father.",
          "\"The roar is thunder, little son,\" his father said, \"and the fire in the sky is lightning.\"",
          "\"I am so proud of you, Little Hawk!\"",
          "\"You are brave enough to fight the thunder and the lightning.\"",
          "From this day on, I will call you Brave Hawk.\""
        ]
      }
    ],
    "questions": [
      {
        "text": "Little Hawk thinks thunder is a ____.",
        "distractors": [
          "roaring man",
          "roaring animal",
          "rain storm"
        ],
        "correct": "roaring animal"
      },
      {
        "text": "Little Hawk is given a new ____ by his father.",
        "distractors": [
          "name",
          "bow",
          "pet animal"
        ],
        "correct": "name"
      }
    ]
  },
  {
    "grade": "2",
    "author": " ",
    "title": "Surprise",
    "storyid": "366eac40-7117-11e9-84af-87f1ff3e5777",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "Dad came home today and said, 'I am going to get you a surprise this weekend.'",
          "I asked, 'What is it, Dad? What is the surprise?'",
          "Dad said, 'You will just have to wait and see.'",
          "I waited all week long to see what my surprise would be.",
          "I was getting very excited.",
          "On Friday, I went to spend the night with my best friend.",
          "I told my friend, 'I am going to get a surprise tomorrow.'",
          "The next morning, my mom came over and picked me up.",
          "I asked Mom, 'What is my surprise?'",
          "'You will just have to wait a little longer,' said Mom.",
          "When I walked in the house, my dad handed me a small stick.",
          "'Where is my surprise?' I asked.",
          "'This is it,' said Dad.",
          "I looked at the stick, and I was very upset.",
          "I ran into the backyard to play.",
          "As soon as I stepped outside, I stopped.",
          "There in the backyard was a little yellow puppy.",
          "'Surprise!' yelled Dad.",
          "I smiled and ran to hug my new puppy.",
          "Dad said, 'You can teach your puppy to bring the stick back to you.'",
          "It was the best surprise I've ever had."
        ]
      }
    ],
    "questions": [
      {
        "text": "The ____ is the surprise.",
        "distractors": [
          "stick",
          "puppy",
          "toy"
        ],
        "correct": "puppy"
      },
      {
        "text": "The stick is ____ at first.",
        "distractors": [
          "funny",
          "exciting",
          "upsetting"
        ],
        "correct": "upsetting"
      }
    ]
  },
  {
    "grade": "2",
    "author": " ",
    "title": "Fire Trucks",
    "storyid": "a3970ea0-5fc6-11e9-afeb-97aa28d47c59",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "Have you ever heard the siren from a fire truck on its way to a fire?",
          "In fact, did you know that a fire truck siren is as loud as a clap of thunder?",
          "It has to be that loud so that everyone will hear it and get out of the way.",
          "Fire trucks do a lot more than just carry firefighters to a fire.",
          "They also carry all of the gear that helps put out the fire.",
          "Gear is another name for all of the tools on the fire truck.",
          "A fire truck is like a big toolbox on wheels.",
          "Firefighters need many different tools to help them put out fires.",
          "They use axes to chop down walls so they can get to the fire.",
          "They also use them to chop holes in the roof so the smoke can get out.",
          "Firefighters also need other tools.",
          "They poke holes in houses with pike poles.",
          "They also carry tanks of air.",
          "Firefighters wear air tanks and special masks to protect them from the smoke of the fire.",
          "The tanks provide them with the air they need.",
          "A fire truck also carries long water hoses.",
          "The firefighters spray water on the fire to put it out.",
          "When a fire is too high up, they use a ladder to help them reach the flames.",
          "Firefighters need fire trucks to do their job everyday.",
          "That is why a fire truck is just like a toolbox on wheels."
        ]
      }
    ],
    "questions": [
      {
        "text": "Tanks provide ____ for the firefighters.",
        "distractors": [
          "water",
          "air",
          "food"
        ],
        "correct": "air"
      },
      {
        "text": "Fire trucks are ____ for the firefighters.",
        "distractors": [
          "toolboxes",
          "home base",
          "a lot of trouble"
        ],
        "correct": "toolboxes"
      }
    ]
  },
  {
    "grade": "2",
    "author": " ",
    "title": "Tadpole To Frog",
    "storyid": "7b0391e0-725c-11e9-9048-67e3d3231e74",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "Every spring, frogs lay their eggs in ponds.",
          "Each egg looks like a ball of clear jelly, and has a dark center.",
          "The eggs stick together.",
          "These clumps of eggs are called frog spawn.",
          "Inside each egg, a tiny tadpole is growing.",
          "At first, the tadpole looks like a speck of dirt.",
          "After a few days, a little head and a small tail take shape.",
          "Soon, the tadpole wiggles out of its egg and swims away.",
          "A tadpole has gills on the outside of its body to let it breathe under the water.",
          "A strong and long tail helps it to swim to find food.",
          "So, each day, the tadpole grows bigger.",
          "But, the tadpole gets big without looking like a frog.",
          "Then, the tadpole starts to change.",
          "Two hind legs appear.",
          "The gills move inside the body.",
          "Now and then, the tadpole puts its head above the water to take a breath.",
          "The tadpole's lungs grow stronger and bigger.",
          "Then, two front legs start to grow.",
          "The tadpole's mouth grows wider.",
          "And, the tadpole begins to eat tiny little bugs.",
          "After a few more weeks, the tadpole's tail begins to get smaller.",
          "Webs start to appear on the feet.",
          "The hind legs get longer and stronger.",
          "Step by step, the tadpole has become a little frog.",
          "Now, the frog starts to spend time out of the water.",
          "On land, the frog finds bugs and worms to eat.",
          "After a year or two, the frog is grown up.",
          "Then, the frog lays new eggs."
        ]
      }
    ],
    "questions": [
      {
        "text": "A frog starts as an ____ and ends as an adult frog.",
        "distractors": [
          "little frog",
          "tadpole",
          "egg"
        ],
        "correct": "egg"
      },
      {
        "text": "A big change is the ____ moving inside the tadpole's body.",
        "distractors": [
          "legs",
          "gills",
          "tail"
        ],
        "correct": "gills"
      }
    ]
  },
  {
    "grade": "2",
    "author": " ",
    "title": "And Also",
    "storyid": "4eb70920-73f9-11e9-8136-d347a99395f7",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "Tim pretends that his bed is a raft on the sea!",
          "His little sister Kim says, \"Yes! And also! There are sharks.\"",
          "\"No!\" says Tim.",
          "Tim pretends that their car is a spaceship!",
          "Kim says, \"Yes!\"",
          "\"And also! Watch out for shooting stars!\"",
          "\"No,\" says Tim.",
          "Tim pretends the playground is a jungle!",
          "His little sister says, \"Yes! And also! We are lions.\"",
          "\"No,\" says Tim.",
          "\"Oh!\" says Tim, \"Wait! Wow! Yes!\"",
          "\"That is a great idea!\"",
          "\"I know!\" says Kim.",
          "Tim pretends to be a lion!",
          "Kim also pretends to be a lion!",
          "Tim pretends the other kids are crocodiles in a river!",
          "Kim says, \"Yes! And also! We can jump on this log to get away.\"",
          "\"Yes! And also!\" Tim says, \"We can slide down the rainbow!\"",
          "Kim says, \"Yes! And also! Watch out for the dragons!\"",
          "Tim says, \"I had the best day playing pretend with you.\"",
          "Kim says, \"Me too.\"",
          "\"And also, we should play again tomorrow!\""
        ]
      }
    ],
    "questions": [
      {
        "text": "Tim is a big ____.",
        "distractors": [
          "liar",
          "pretender",
          "lion"
        ],
        "correct": "pretender"
      },
      {
        "text": "They pretend the other kids are ____ in a river.",
        "distractors": [
          "dragons",
          "lions",
          "crocodiles"
        ],
        "correct": "crocodiles"
      }
    ]
  },
  {
    "grade": "2",
    "author": " ",
    "title": "Jimmy Getz Loves Pets",
    "storyid": "c7b13d30-725c-11e9-9048-67e3d3231e74",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "The interesting thing about little Jimmy Getz is that he really loves pets!",
          "It started with a hamster from the local store.",
          "He loved it so much that he bought twelve more.",
          "But it doesn't stop there.",
          "He got a poodle and a hare.",
          "Plus, he got a badger and a fox.",
          "He put them both in a box.",
          "He also got birds, like an owl.",
          "And, he got a great big ostrich too.",
          "The ostrich had a foul temper.",
          "So, Jimmy got a parrot.",
          "Then he got a vampire bat.",
          "And, he gave that bat a hat.",
          "He thought keeping fish would be a laugh.",
          "So, a shark now lives in his bath.",
          "His local fish store had a sale.",
          "Jimmy ended up with a whale.",
          "Then Jimmy got some penguins too.",
          "He made an ice rink By freezing water in the sink.",
          "To guard his animals, Jimmy got a cheetah.",
          "Then he got a kangaroo, Who just loved to shout boo!",
          "A pair of giraffes lives in the garage.",
          "So now there is no room for the car.",
          "This sounds amazing but it is true.",
          "Cows are grazing on Jimmy's lawn.",
          "A rooster wakes him up at dawn.",
          "In Jimmy's shower he keeps an otter.",
          "He loves to bathe in cold water.",
          "And, that's the list of Jimmy's pets.",
          "at least until he goes back for more, because Jimmy loves to go to the store."
        ]
      }
    ],
    "questions": [
      {
        "text": "Jimmy gets his pets ____.",
        "distractors": [
          "at the ice rink",
          "at the store",
          "at the zoo"
        ],
        "correct": "at the store"
      },
      {
        "text": "____ lives in Jimmy's shower.",
        "distractors": [
          "A whale",
          "An otter",
          "A penguin"
        ],
        "correct": "An otter"
      }
    ]
  },
  {
    "grade": "2",
    "author": " ",
    "title": "Bird's Nest",
    "storyid": "b3f5fce0-7117-11e9-84af-87f1ff3e5777",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "It was a beautiful spring day.",
          "I went into the garage to get my bike.",
          "There I saw a small bird hopping down from my dad's storage closet.",
          "The next afternoon I saw the bird again.",
          "This time the bird had a stick in her mouth.",
          "She was hopping up to the highest shelf.",
          "I looked up and saw a bird's nest in a box.",
          "I wondered why the bird had built her nest on the top shelf of my dad's storage closet.",
          "Soon, the nest had four colorful eggs.",
          "The eggs soon hatched.",
          "The mother bird became very busy feeding her babies.",
          "She would bring crickets into the nest for her babies to eat.",
          "My cat found out about the nest when he heard the babies chirping.",
          "The top shelf was too high to reach.",
          "He would go back and forth in front of the nest flipping his tail.",
          "I know now why the bird built her nest on the top shelf of my dad's storage closet."
        ]
      }
    ],
    "questions": []
  },
  {
    "grade": "2",
    "author": " ",
    "title": "Extraordinary Birds",
    "storyid": "ad084800-7fb5-11e9-82b6-b984767f10dc",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "I keep climbing the tree.",
          "I am an amazing climber.",
          "When I grow up, I could if I wanted, make my living climbing rocks and mountains.",
          "I could climb the tallest tree in the world, which right now is a redwood growing somewhere in California.",
          "Its name is Hyperion and it's three hundred seventy nine feet all.",
          "But a tree like Hyperion is not my flight tree.",
          "The tree I'm destined to take flight from is unique, but easier to find.",
          "Live oak trees grow everywhere around here.",
          "It will be an older oak, its branches gnarled and twisting out and up, with lots of perfect places to build a nest.",
          "That tree, my flight tree, will stand by itself in a field somewhere, waiting for me all its life.",
          "I am training myself to get better at ignoring being scared, the fast heartbeat, sweaty palms, the breathing.",
          "I don't have a choice. I am built to climb, but I was born to fly.",
          "I do not have much weight to carry, and my bones are light, but strong and flexible.",
          "\"You are going to fall!\" Karen shouts up at me.",
          "She's wearing an orange shirt. I don't like orange.",
          "It's the opposite of blue, my favorite color.",
          "Of course, I know I'm going to fall.",
          "That's how baby birds learn to fly.",
          "The first few times they try, they fall to the ground, but they learn they can make the impact easier by spreading their wings.",
          "Karen keeps shouting; she's real mad. But, I don't care.",
          "She shouldn't try to make me eat food that goes against my nature.",
          "I like seeds, sunflower more than pumpkin.",
          "This morning I sat down at the table and poured myself a bowl of sunflower seeds instead of Cheerios.",
          "Then Karen said something about how I was too skinny and if I didn't eat more than seeds, that one day I would \"up and fly away.\"\n\nI do not want to jump from too high in the tree.",
          "I am not ready. But I have to keep challenging myself.",
          "Everyone's concerned about me getting hurt.",
          "They think I will break my arm or leg or shoulder. They shouldn't worry.",
          "Now Karen is on her cell phone. \"Yes, this an emergency\", I hear her saying.",
          "There are lots of ways to take off and fly.",
          "Birds can run into the wind and catch a current beneath their wings, or leap from someplace high and fall into the fair.",
          "Lately, I have been falling into the air.",
          "It is more dangerous, but the other way wasn't working.",
          "Karen says: \"Please, just stay where you are.\" I think about Amelia Earhart.",
          "I wrote a report on her, and I will always remember reading three things that she said:\n\"Never interrupt someone doing something you said could not be done.\"\n\"You haven't seen a tree until you've seen its shadow from the sky.\"\nAnd, \"What do dreams know of boundaries?\"\n\nSirens are coming this way.",
          "A fire truck turns down the street. I am the emergency.",
          "\"Dear Amelia,\" I whisper, \"please give me the aerodynamics of thin bones and features.\" When it is time, I know the scar on my back will tingle and my wings will finally burst out, unfurling through my skin.",
          "I just need to step off the branch. I will fly.",
          "Jumping into the air is the easy part."
        ]
      }
    ],
    "questions": [
      {
        "text": "Amelia Earhart said ____ have no boundaries.",
        "distractors": [
          "flyers",
          "dreams",
          "trees"
        ],
        "correct": "dreams"
      },
      {
        "text": "Karen fears the girl will ____.",
        "distractors": [
          "not come home",
          "fly",
          "fall"
        ],
        "correct": "fall"
      }
    ]
  },
  {
    "grade": "2",
    "author": " ",
    "title": "Bucking Horse",
    "storyid": "6c3291a0-7259-11e9-9048-67e3d3231e74",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "My grandpa has horses on his farm.",
          "He has been teaching me how to ride.",
          "The horse I rode was named Scooter, and I pretended that he was all mine.",
          "Scooter was very gentle.",
          "He stopped when I said, \"Whoa.\"",
          "He walked slowly and never ran.",
          "I brought a friend to the farm with me last weekend.",
          "I suggested we ride horses as soon as we got there.",
          "Grandpa let my friend ride Scooter because he was so gentle.",
          "He put me up on his horse, Buck.",
          "Buck is not as gentle as Scooter, so I felt a little uneasy.",
          "Everything was going fine, when all of a sudden Buck started to buck!",
          "The next thing I knew, I was on the ground.",
          "Grandpa was rushing off of his horse to see about me.",
          "I was fine, but a bit shook-up.",
          "Buck was still running and bucking.",
          "Grandpa said a bee must have stung him.",
          "When we got to school on Monday, my friend told everyone that I could ride bucking horses.",
          "He said I was a real cowboy."
        ]
      }
    ],
    "questions": [
      {
        "text": "Scooter was ____ and easy to ride.",
        "distractors": [
          "old",
          "gentle",
          "red"
        ],
        "correct": "gentle"
      },
      {
        "text": "Buck ____.",
        "distractors": [
          "bucked",
          "trotted",
          "stopped"
        ],
        "correct": "bucked"
      }
    ]
  },
  {
    "grade": "1",
    "author": " ",
    "title": "Running",
    "storyid": "fe3e4b00-7256-11e9-b1bd-83894e919c91",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "\"I like to run,\" said Pam.",
          "\"It is fun.",
          "\"I can run like the wind.\"",
          "\"Do you wish to run with me on the road today?\"",
          "\"No, you run too fast for me,\" said Meg.",
          "\"I will walk, and you can run on the road.\"",
          "Pam said, \"Come on, Meg.\"",
          "\"Run with me.\"",
          "\"It will be fun to run together.\"",
          "\"You can run,\" said Meg.",
          "\"I do not like running.\"",
          "\"I fall down when I run.\"",
          "\"I like walking better.\"",
          "\"We will not run so fast that you will fall.\"",
          "\"I will run near you,\" said Pam.",
          "Pam and Meg ran.",
          "They ran to the park.",
          "They ran to the house.",
          "They ran by the school.",
          "They ran really far.",
          "Meg was happy that she did not fall."
        ]
      }
    ],
    "questions": [
      {
        "text": "Meg worried about ____ when she ran.",
        "distractors": [
          "cramping",
          "falling",
          "limping"
        ],
        "correct": "falling"
      },
      {
        "text": "They ran by ____.",
        "distractors": [
          "Pam's house",
          "the school",
          "the beach"
        ],
        "correct": "the school"
      }
    ]
  },
  {
    "grade": "1",
    "author": " ",
    "title": "Big Dog",
    "storyid": "03334150-7258-11e9-bbe8-11edd823450e",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "\"Look at that dog over there,\" said Skip.",
          "\"That is a really big dog,\" said Danny.",
          "\"I want to pet the dog,\" said Skip.",
          "\"Do you think we can pet him?\"",
          "\"If we get too close, the dog may run away,\" said Danny.",
          "\"No,\" said Skip, \"I think this is a friendly dog.\"",
          "\"I think he will let us pet him. Watch me.\"",
          "\"Let me pet the dog first,\" said Danny.",
          "\"Look, he licked my hand!\"",
          "\"He is a nice dog.\"",
          "\"Now, let me pet him,\" said Skip.",
          "\"He is such a good dog, and he feels soft.\"",
          "\"We can play with him,\" said Danny.",
          "\"We can run out to the trees with him.\"",
          "\"We will have fun with the big, big dog,\" said Skip."
        ]
      }
    ],
    "questions": [
      {
        "text": "When big dog is petted, he ____ Danny's hand.",
        "distractors": [
          "bites",
          "noses",
          "licks"
        ],
        "correct": "licks"
      },
      {
        "text": "This story is about ___ boys and a dog.",
        "distractors": [
          "one",
          "two",
          "three"
        ],
        "correct": "two"
      }
    ]
  },
  {
    "grade": "1",
    "author": " ",
    "title": "My Cat Sam",
    "storyid": "81143fb0-5585-11e9-b3e5-f17a2d74382b",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "Sam is my pet cat.",
          "She is a yellow cat.",
          "She likes to jump and run.",
          "She likes to play with me.",
          "Sam likes to sit in my lap.",
          "I like to pet Sam.",
          "She likes to sit in the sun and nap.",
          "Sam naps on the rug.",
          "'Look, Sam,' I say.",
          "'Look at the rat.'",
          "Sam sits up.",
          "She sees the rat.",
          "Sam runs to the rat.",
          "The rat runs away.",
          "Sam is a good cat.",
          "She is my pal."
        ]
      }
    ],
    "questions": [
      {
        "text": "Sam ____ the rat.",
        "distractors": [
          "runs at",
          "catches",
          "eats"
        ],
        "correct": "runs at"
      },
      {
        "text": "Sam is a ____.",
        "distractors": [
          "rat",
          "cat",
          "girl"
        ],
        "correct": "cat"
      }
    ]
  },
  {
    "grade": "1",
    "author": " ",
    "title": "Bud Gets the Ball",
    "storyid": "c7524e70-7116-11e9-84af-87f1ff3e5777",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "Bud is my dog.",
          "Bud is my pal.",
          "Bud and I like to play ball.",
          "Bud and I like to run in the sun.",
          "Bud likes to play with the red ball.",
          "I toss the red ball to Bud.",
          "Go get the ball! He looks and looks for the ball.",
          "Bud cannot see the ball.",
          "I go help Bud.",
          "I look and look for the ball.",
          "I see the ball.",
          "Bud sees the ball.",
          "He runs to the ball.",
          "Bud gets the red ball.",
          "Let me have the ball, Bud.",
          "Bud comes to me.",
          "He gives the red ball to me.",
          "Bud is a good dog."
        ]
      }
    ],
    "questions": []
  },
  {
    "grade": "1",
    "author": " ",
    "title": "The Goat",
    "storyid": "003b4b40-5fc6-11e9-afeb-97aa28d47c59",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "Mom and dad take Peter and Mike to the zoo.",
          "First, the boys go to the petting zoo.",
          "They go in the pen.",
          "They feed the goats.",
          "One of the goats follows them out of the pen gate.",
          "Peter and Mike do not see the goat following them.",
          "'Stop following those boys!' yelled the helper at the goat.",
          "'Don't leave the pen!'",
          "The goat ran from the pen and the helper chased after it.",
          "'What fun!' said Peter.",
          "'Let's chase after the goat, too,' said Mike.",
          "It was very funny watching Mike and Peter chasing after the goat.",
          "'Time to stop chasing the goat!' shouted mom.",
          "'It is time to eat lunch.'",
          "'Our food looks better than the animals' food,' said Peter.",
          "Peter and Mike were tired from chasing the goat.",
          "They were glad to sit at the picnic table and eat lunch with mom and dad."
        ]
      }
    ],
    "questions": [
      {
        "text": "The goat ____ the boys.",
        "distractors": [
          "attacks",
          "follows",
          "licks"
        ],
        "correct": "follows"
      },
      {
        "text": "Peter thinks ____ food doesn't look good.",
        "distractors": [
          "Mom's",
          "the goat's",
          "the keeper's"
        ],
        "correct": "the goat's"
      }
    ]
  },
  {
    "grade": "1",
    "author": " ",
    "title": "See An Elephant",
    "storyid": "02eb6840-74dc-11e9-97ec-692434f2ed7f",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "I See an Elephant.",
          "\"I am Sam,\" said the man.",
          "\"I see an elephant,\" said Sam.",
          "\"I am Nan,\" said the elephant.",
          "\"I am an elephant,\" said Nan.",
          "\"An elephant sees me,\" said Sam.",
          "I See the two seeds.",
          "\"I am Sam,\" said the man.",
          "\"I am Sam, and I see seeds,\" said the man.",
          "\"I am Sam, and I see two seeds,\" said the man.",
          "\"I am Sam, and I see the two seeds,\" said the man.",
          "\"I am 1 man, and I see the two seeds,\" said the man.",
          "I'm one man.",
          "I'm Sam.",
          "Sam sees two seeds."
        ]
      }
    ],
    "questions": [
      {
        "text": "____ is the elephant",
        "distractors": [
          "Sam",
          "Nan",
          "The seeds"
        ],
        "correct": "Nan"
      },
      {
        "text": "Sam sees ____",
        "distractors": [
          "both the elephant and the seeds",
          "both seeds and a dog",
          "Nan and one seed"
        ],
        "correct": "both the elephant and the seeds"
      }
    ]
  },
  {
    "grade": "1",
    "author": " ",
    "title": "Elephants Are Big",
    "storyid": "2b3c77e0-7328-11e9-b491-3358089dfb6b",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "Everything about an elephant is big.",
          "It has big ears.",
          "It has big eyes and big tusks.",
          "It can weigh as much as a school bus!",
          "An elephant also has a long trunk.",
          "It uses its trunk to breathe and to smell.",
          "It uses its trunk to find leaves and fruits to eat.",
          "An elephant can shower itself with its trunk.",
          "It sucks up water and sprays its back.",
          "A mother elephant can hold her baby close with her trunk.",
          "She can even use her trunk to help lift her baby or move it away from trouble.",
          "For example, she might use her trunk to save her baby from getting stuck in mud!",
          "An elephant's trunk is like a hand that can pick things up like an arm that is longer than a kid is tall."
        ]
      }
    ],
    "questions": [
      {
        "text": "Elephants weigh as much as a ____.",
        "distractors": [
          "horse",
          "house",
          "bus"
        ],
        "correct": "bus"
      },
      {
        "text": "Based on the story, an elephant's trunk is ____.",
        "distractors": [
          "just like a human nose",
          "important for many reasons",
          "mainly to care for babies"
        ],
        "correct": "important for many reasons"
      }
    ]
  },
  {
    "grade": "1",
    "author": " ",
    "title": "Little Ant's Big Plan",
    "storyid": "ebf41c10-7420-11e9-bc59-ab06df4fe462",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "Little Ant loved to read.",
          "Little Ant was often teased.",
          "\"Ants don't read.\"",
          "\"Ants must feed.\"",
          "\"Ants collect the food they need.\"",
          "Little Ant would read all day, he'd read and read the day away.",
          "The other ants took what they found to store for winter underground.",
          "His mom and dad got really mad, and Little Ant felt really bad.",
          "In autumn when the leaves fall down, the ants must keep food underground.",
          "The Queen wants food to ﬁll the store, so all the ants must work some more.",
          "Little Ant begins to shout about a place he read about.",
          "\"A restaurant is what we need, a place where people go to feed.\"",
          "\"It says so in the books I read.\"",
          "\"The ants go marching one by one.\"",
          "\"They march into the setting sun.\"",
          "And Little Ant said \"Hey, there's one!\"",
          "The ants go marching one by one, carrying a burger, carrying a bun.",
          "When they return the Queen is glad.",
          "The stores are full.",
          "They cheer like mad.",
          "Ant gets hugs from mum and dad.",
          "His baby sister takes his hand \"Now I think I understand.\"",
          "\"The way you love to read a book makes me want to take a look.\""
        ],
      }
    ],
    "questions": [
      {
        "type": "cloze",
        "text": "Most ants feed but Little Ant ____.",
        "distractors": [
          "sleeps",
          "reads",
          "sings"
        ],
        "correct": "reads"
      },
      {
        "type": "cloze",
        "text": "Little Ant uses a book to ____ food.",
        "distractors": [
          "find",
          "carry",
          "forget about"
        ],
        "correct": "find"
      }
    ]
  },
  {
    "grade": "1",
    "author": " ",
    "title": "Mick Can Dream",
    "storyid": "a1e7c100-548e-11e9-b497-ad0e2cf02415",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "I am Mick, and I can dream,' said Mick.",
          "It is a kick that I can dream,' he said.",
          "At night I can dream and dream,' said Mick.",
          "'I dream that I am a moose,' he said.",
          "'I dream I am a moose in the forest,' said Mick.",
          "'It is neat that I can dream,' he said."
        ]
      }
    ],
    "questions": []
  },
  {
    "grade": "1",
    "author": " ",
    "title": "Sleep Mister Sloth",
    "storyid": "adc96d80-7422-11e9-bc59-ab06df4fe462",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "One day, Mr Sloth came to visit.",
          "He said, \"I'm sleepy! I need a good branch for a bed!\"",
          "\"I'm quite good at climbing.\"",
          "\"I know how to swing.\"",
          "\"But sleeping's my favorite, favorite thing!\"",
          "\"This branch looks lovely!\"",
          "\"I think I'll sleep here.\"",
          "\"And you? Don't you think that's a splendid idea?\"",
          "\"Oh no, Mr Sloth! A giraffe's eating there!\"",
          "\"He might think you're lunch and start nibbling your hair!\"",
          "\"This branch looks lovely!\"",
          "\"I think I'll sleep here.\"",
          "\"And you? Don't you think that's a splendid idea?\"",
          "\"Oh no, Mr Sloth! There's a beehive right there!\"",
          "\"You'll never get sleep with those bees everywhere!\"",
          "\"This branch looks lovely! I think I'll sleep here.\"",
          "\"And you? Don't you think that's a splendid idea?\"",
          "\"Oh no, Mister Sloth, that's a snake over there!\", said the giraffe.",
          "\"Not a branch!\"",
          "\"Poor old snake.\"",
          "\"You gave him quite a scare.\"",
          "Said Mister Sloth, \"This branch looks lovely! I think I'll sleep here.\"",
          "\"And you? Don't you think that's a splendid idea?\"",
          "\"Oh no, Mister Sloth! There's a bird squawking there!\", said the snake.",
          "\"You'll never get sleep with that noise in the air!\"",
          "\"Try to climb up one more branch, Mister Sloth!\" all the bees said.",
          "And that branch was just the right one for his bed.",
          "The bird and the snake, the giraffe and each bee were happy to have Mister Sloth in their tree."
        ]
      }
    ],
    "questions": [
      {
        "type": "cloze",
        "text": "Mr. Sloth climbed the tree hoping to ____.",
        "distractors": [
          "find food",
          "see his friends",
          "find a place to sleep"
        ],
        "correct": "find a place to sleep"
      },
      {
        "type": "cloze",
        "text": "The bees ____ Mr. Sloth.",
        "distractors": [
          "stung",
          "bothered",
          "made honey for"
        ],
        "correct": "bothered"
      }
    ]
  },
  {
    "grade": "1",
    "author": " ",
    "title": "Too Big, Too Small",
    "storyid": "fe31b230-6f74-11e9-822b-7b84badf7063",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "'I can not lift you up, Shanu,' Mom said.",
          "'You are too big.'",
          "'You can not walk alone.'",
          "'You are too small.'",
          "'You can not sleep in baby's bed', says Grandpa.",
          "'You are too big.'",
          "'And, you can not hold baby.'",
          "'You are too small.'",
          "'How can this be?', says Shanu.",
          "'How can I be too small and too big?'",
          "Too big to climb on Dad's lap.",
          "Too small to hold baby.",
          "'What am I the right size to do?' says Shanu.",
          "'What can I do?'",
          "Mom smiles and says, 'You are big enough to go to school.'",
          "'You are the right size for this!', all say.",
          "And, Shanu gets a big hug."
        ]
      }
    ],
    "questions": [
      {
        "type": "cloze",
        "text": "A ____ is right for Shanu's size.",
        "distractors": [
          "baby's bed",
          "hug",
          "Dad's lap"
        ],
        "correct": "hug"
      },
      {
        "type": "cloze",
        "text": "Shanu is big enough to ____.",
        "distractors": [
          "go to school",
          "hold a baby",
          "walk alone"
        ],
        "correct": "go to school"
      }
    ]
  },
  {
    "grade": "1",
    "author": " ",
    "title": "Chirp",
    "storyid": "bc558300-7258-11e9-bbe8-11edd823450e",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "I have a pet bird named Chirp.",
          "He is a very pretty bird.",
          "Everybody likes him, even my dog.",
          "Chirp loves to get out of his cage.",
          "He can lift the latch all by himself.",
          "I always keep my bedroom door closed because we don't want Chirp to fly away.",
          "One day I forgot to close my door.",
          "Chirp got outside, and I was very upset.",
          "I went out in the yard to look for him.",
          "I found him up in a tree next to our house.",
          "He was singing away, so glad to be free.",
          "I got a mirror and went up the tree.",
          "I held the mirror in front of Chirp.",
          "He looked in the mirror and pecked on it.",
          "While he was looking at the bird in the mirror, I put my hand around him.",
          "\"I got him!\" I shouted.",
          "Everybody was so glad that I had gotten Chirp back.",
          "Dad fixed the latch on the birdcage with some wire.",
          "Chirp is busy working on the wire."
        ]
      }
    ],
    "questions": [
      {
        "type": "cloze",
        "text": "Chirp is able to ____ the latch.",
        "distractors": [
          "lift",
          "peck",
          "fix"
        ],
        "correct": "lift"
      },
      {
        "type": "cloze",
        "text": "Chirp gets caught because he ____.",
        "distractors": [
          "wants some food",
          "falls asleep",
          "looks in the mirror"
        ],
        "correct": "looks in the mirror"
      }
    ]
  },
  {
    "grade": "1",
    "author": " ",
    "title": "Playing House",
    "storyid": "6f5c01a0-7258-11e9-bbe8-11edd823450e",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "My name is Jan.",
          "My best friend is Tasha.",
          "We like to play with my new doll.",
          "We call her Ruby.",
          "We like to play house.",
          "I like to be the Mommy.",
          "Tasha is the Daddy.",
          "We play that we are a happy family.",
          "We play well together.",
          "One day Tasha said, \"I want to be Ruby's mommy, too.\"",
          "I said, \"No, Ruby is my new doll.\"",
          "Tasha was sad.",
          "I was getting mad.",
          "Tasha said, \"I want to go home.\"",
          "I felt bad.",
          "My mom said friends should play well together.",
          "I said, \"You can be Ruby's mommy, and I will be the Daddy.\"",
          "Tasha was happy.",
          "She did not go home."
        ]
      }
    ],
    "questions": []
  },
  {
    "grade": "1",
    "author": " ",
    "title": "Fun in the Sand",
    "storyid": "ede68ec0-7116-11e9-84af-87f1ff3e5777",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "Sam likes to play in the sand.",
          "Sam makes three dogs in the sand.",
          "Pam likes to play in the sand.",
          "Pam makes three cats in the sand.",
          "Look at the dogs and cats in the sand.",
          "The dogs and cats look funny.",
          "Pam and Sam have fun.",
          "Pam and Sam play in the sand.",
          "Pam and Sam are pals.",
          "Pam helps Sam.",
          "Sam helps Pam.",
          "Pam and Sam have fun in the sun.",
          "Pam and Sam have fun in the sand."
        ]
      }
    ],
    "questions": [
      {
        "type": "cloze",
        "text": "Sam likes to ____ the sand.",
        "distractors": [
          "sleep on",
          "play in",
          "make cats with"
        ],
        "correct": "play in"
      },
      {
        "type": "cloze",
        "text": "Pam makes ____ cats in the sand.",
        "distractors": [
          "two",
          "three",
          "four"
        ],
        "correct": "three"
      }
    ]
  },
  {
    "grade": "1",
    "author": "Unknown",
    "title": "Five Little Turkeys",
    "storyid": "c12e53c0-1e70-11e9-ae42-8b4b4946542e",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "Once upon a time, there were five little turkeys sitting on a plate.",
          "The first one said, 'Doesn't this table look great?'",
          "The second one said, 'I smell pie.'",
          "The third one said, 'I love pie.'",
          "The fourth one said, 'Oh no. Why are we on a plate?'",
          "The fifth one said, 'Let's run, let's run, before the people come.'",
          "And then 'Ding Dong' went the doorbell, and all five turkeys ran."
        ]
      }
    ],
    "questions": [
      {
        "type": "cloze",
        "text": "When the ____, the turkeys ran.",
        "distractors": [
          "clock chimed",
          "pie cooked",
          "doorbell rang"
        ],
        "correct": "doorbell rang"
      },
      {
        "type": "cloze",
        "text": "The second turkey smelled ____.",
        "distractors": [
          "pie",
          "stuffing",
          "flowers"
        ],
        "correct": "pie"
      }
    ]
  },
  {
    "grade": "0",
    "author": " ",
    "title": "My Best Friend",
    "storyid": "03a06c60-6f76-11e9-822b-7b84badf7063",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "I have a friend.",
          "She lives with me.",
          "When I am happy, so is she.",
          "When I cry, so does she.",
          "But I can not hear her talk.",
          "My friend is in the mirror.",
          "'Come out', I say.",
          "But my friend will not come out.",
          "'Come out and we will play', I say.",
          "But she will not.",
          "Then I am not happy.",
          "So, I go to sleep.",
          "Then, she comes out and plays.",
          "And we have fun.",
          "We play.",
          "We run.",
          "We have fun.",
          "Then we sing.",
          "And, when I talk, she talks back.",
          "When I wake up, my friend will go back into the mirror.",
          "But, I will see her when I go to sleep.",
          "And, then we will play more."
        ]
      }
    ],
    "questions": []
  },
  {
    "grade": "0",
    "author": " ",
    "title": "Mom Has a Bag",
    "storyid": "ed89bbb0-74da-11e9-97ec-692434f2ed7f",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "Mom has a bag.",
          "A red hat is in the bag.",
          "The hat is for Dad.",
          "Mom sees a cat.",
          "Oh no! Now the cat is in the bag.",
          "The cat sat on the hat!",
          "That hat is for Dad, cat.",
          "Scat cat!",
          "Now the cat is out of the bag.",
          "She is on the mat.",
          "The hat is on Dad.",
          "Mom and Dad pat the cat."
        ]
      }
    ],
    "questions": [
      {
        "type": "cloze",
        "text": "The hat is ____.",
        "distractors": [
          "red",
          "blue",
          "green"
        ],
        "correct": "red"
      },
      {
        "text": "____ wears the hat.",
        "distractors": [
          "Mom",
          "The cat",
          "Dad"
        ],
        "correct": "Dad"
      }
    ]
  },
  {
    "grade": "0",
    "author": " ",
    "title": "Flower",
    "storyid": "5464d700-74dd-11e9-97ec-692434f2ed7f",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "\"I am a flower,\" said the flower.",
          "\"Flowers need rain,\" said the flower.",
          "\"I see the rain.\"",
          "\"I need the rain,\" said the flower.",
          "The flower said, \"I am a flower, and I need rain.\"",
          "Rain helps flowers grow.",
          "So, flowers need rain."
        ]
      }
    ],
    "questions": [
      {
        "type": "cloze",
        "text": "Flowers need ____.",
        "distractors": [
          "rain",
          "love",
          "growth"
        ],
        "correct": "rain"
      },
      {
        "type": "cloze",
        "text": "In the story, the ____ says flowers need rain.",
        "distractors": [
          "boy",
          "rain",
          "flower"
        ],
        "correct": "flower"
      }
    ]
  },
  {
    "grade": "0",
    "author": " ",
    "title": "A Street Or a Zoo?",
    "storyid": "27ca0560-6f62-11e9-822b-7b84badf7063",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "Sam, Mo and Rina set out to play.",
          "They saw a kitten.",
          "She was looking at a big rat.",
          "'Look', said Sam.",
          "Rina saw an ant by the big rat.",
          "Then a big shadow came over them all.",
          "A big bird came down.",
          "An ant, a kitten, a rat and a big bird on the same road. Wow.",
          "What would the kids do now?",
          "They clapped their hands!",
          "The bird flew away.",
          "Rina made the ant walk onto a leaf.",
          "The ant saw some sugar.",
          "The ant took it home.",
          "The rat picked up some food too.",
          "Then the rat went home.",
          "The kitten licked her paw.",
          "Mo got her some milk.",
          "The three kids played with her.",
          "The big bird in the tree then flew far away."
        ]
      }
    ],
    "questions": [
      {
        "type": "cloze",
        "text": "The kids ____ the bird by clapping.",
        "distractors": [
          "scare",
          "make friends with",
          "summon"
        ],
        "correct": "scare"
      },
      {
        "type": "cloze",
        "text": "There were ____ kids in the story.",
        "distractors": [
          "one",
          "two",
          "three"
        ],
        "correct": "three"
      }
    ]
  },
  {
    "grade": "0",
    "author": " ",
    "title": "Pin It On",
    "storyid": "71a253c0-6555-11e9-a27c-b51a4ad6f6c6",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "pin it on",
          "not on its leg",
          "not on its chin",
          "not on its tum",
          "yes",
          "that's it",
          "pin it on"
        ]
      }
    ],
    "questions": []
  },
  {
    "grade": "0",
    "author": " ",
    "title": "I Need Sand",
    "storyid": "d9a9e240-74db-11e9-97ec-692434f2ed7f",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "See me.",
          "I am Sam.",
          "See Dad.",
          "I see Dad.",
          "I need Dad.",
          "I see Dad, and I need Dad.",
          "I see sand.",
          "I need sand.",
          "I need sand, and I need Dad.",
          "See me.",
          "I am Sam.",
          "I need Dad and sand.",
          "I See Sand I see sand.",
          "I see the sand.",
          "I see one dad.",
          "I see the dad.",
          "I see sand and one dad.",
          "I see the sand and the dad."
        ]
      }
    ],
    "questions": [
      {
        "type": "cloze",
        "text": "The two in the story are ____ and Dad.",
        "distractors": [
          "Sam",
          "sand",
          "see"
        ],
        "correct": "Sam"
      },
      {
        "type": "cloze",
        "text": "Sam ____ Dad.",
        "distractors": [
          "likes",
          "needs",
          "is"
        ],
        "correct": "needs"
      }
    ]
  },
  {
    "grade": "0",
    "author": " ",
    "title": "I See",
    "storyid": "9debbc50-74dc-11e9-97ec-692434f2ed7f",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "I See one Bear.",
          "I see one bear.",
          "I See one Boy.",
          "I see one boy.",
          "One boy I see.",
          "I see one boy.",
          "I See one Cat.",
          "I see one cat.",
          "One cat I see.",
          "I see one cat.",
          "I See one Dinosaur.",
          "I see one dinosaur.",
          "One dinosaur I see.",
          "I see one dinosaur.",
          "I See one Dog.",
          "I see one dog.",
          "I see one cat.",
          "I see one rat.",
          "I See one Dozer.",
          "I see one dozer.",
          "One dozer I see.",
          "I see one dozer.",
          "I See one Fire Truck.",
          "I see one fire truck.",
          "One fire truck I see.",
          "I see one fire truck.",
          "I See one Football.",
          "I see one football.",
          "One football I see.",
          "I see one football.",
          "I See one Girl.",
          "I see one girl.",
          "One girl I see.",
          "I see one girl.",
          "I See one Jet.",
          "I see one jet.",
          "One jet I see.",
          "I see one jet.",
          "I See one Mouse.",
          "I see one mouse.",
          "I see one cat.",
          "I see one dog.",
          "I See one Pig.",
          "I see one pig.",
          "I See one Rat.",
          "I see one rat.",
          "One rat I see.",
          "I see one rat.",
          "I See one Truck I see one truck.",
          "One truck I see.",
          "I see one truck."
        ]
      }
    ],
    "questions": []
  },
  {
    "grade": "0",
    "author": " ",
    "title": "Big Small",
    "storyid": "3ca88a20-6f61-11e9-822b-7b84badf7063",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "Big. Small. Big dog.",
          "Small dog. Small hat.",
          "Big head. Big hat. Small head.",
          "Dog too small? Or bowl too big?",
          "Baby on big dog. One big. One small. Big dog.",
          "Small coat. Big coat. Small Dog.",
          "One big. One small. Big dog. Small baby.",
          "Small dog. Big man. Small cup. Big cup.",
          "Big dog.Big bowl. Small dog. Big bowl. All good."
        ]
      }
    ],
    "questions": [
      {
        "type": "cloze",
        "text": "There is a ____ in this story.",
        "distractors": [
          "cat",
          "rat",
          "dog"
        ],
        "correct": "dog"
      },
      {
        "type": "cloze",
        "text": "There is also a ____ in the story.",
        "distractors": [
          "baby",
          "owl",
          "dad"
        ],
        "correct": "baby"
      }
    ]
  },
  {
    "grade": "0",
    "author": " ",
    "title": "Nan and Dad",
    "storyid": "3ca2cc40-74dc-11e9-97ec-692434f2ed7f",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "Nan said, \"I see sand.\"",
          "Nan said, \"I see Dad.\"",
          "Nan said, \"I see sand and Dad.\"",
          "The dad said, \"I see sand.\"",
          "The dad said, \"I see Nan.\"",
          "The dad said, \"I see sand and Nan.\"",
          "I see Sam.",
          "I see the good deed.",
          "I see Sam and the good deed.",
          "\"See me,\" said Sam.",
          "\"See me.\"",
          "\"I am Sam,\" said Sam.",
          "\"See me.\"",
          "\"I am Sam.\"",
          "\"I am mad,\" said Sam.",
          "\"See me.\"",
          "\"I am Sam.\"",
          "\"I am mad.\"",
          "\"I am one man,\" said Sam.",
          "\"See me.\"",
          "\"I am Sam.\"",
          "\"I am one mad man,\" said Sam."
        ]
      }
    ],
    "questions": [
      {
        "type": "cloze",
        "text": "Nan sees ____.",
        "distractors": [
          "Pam",
          "ham",
          "sand"
        ],
        "correct": "sand"
      },
      {
        "type": "cloze",
        "text": "Sam is ____.",
        "distractors": [
          "glad",
          "mad",
          "sad"
        ],
        "correct": "mad"
      }
    ]
  },
  {
    "grade": "0",
    "author": " ",
    "title": "The Bug on the Nut",
    "storyid": "19dcc770-74db-11e9-97ec-692434f2ed7f",
    "type": "tutor",
    "chapters": [
      {
        "phrases": [
          "A big bug sits on a nut. The nut is in the mud.",
          "A little pup runs in the sun.",
          "She sees the bug. She wants to have fun.",
          "The pup runs to the mud to give the bug a rub.",
          "But the bug does not want to have fun with the pup.",
          "The bug wants to sit on the nut.",
          "The bug sees the pup and jumps down under the nut.",
          "Soon the pup is in the mud. No bug!",
          "The pup jumps out of the mud and runs in the sun.",
          "The big bug jumps up to sit on the nut."
        ]
      }
    ],
    "questions": [
      {
        "type": "cloze",
        "text": "The bug wants to ____.",
        "distractors": [
          "get a rub",
          "play with pup",
          "sit on nut"
        ],
        "correct": "sit on nut"
      },
      {
        "type": "cloze",
        "text": "The pup goes ____.",
        "distractors": [
          "in the mud",
          "in the nut",
          "in the bug"
        ],
        "correct": "in the mud"
      }
    ]
  },
  {
    "grade": "1",
    "author": " ",
    "title": "Read Aloud (audio)",
    "storyId": "87654321-4321-dcba-4321-fedcba654321",
    "type": "listeningComprehension",
    "nonAudio": "true",
    "chapters": [
      {
        "phrases": [
          `In almost every way, Uni was like all the other unicorns Magnificent mane. Golden hooves. Sparking purple eyes.
          Like the other unicorns, Uni had a special swirly horn with the power to heal and mend.  And like the other
          unicorns, Uni could make wishes come true.`,
          `But there was one thing that definitely set Uni apart... Uni believed that little girls were REAL.`,
          "Trunk",
          "multi-purpose"
        ],
        "items": [
          {
            "type": "readAloud",
            "audioURL": "https://assets.amiratutor.com/audio/comprehension/uni_the_unicorn_1.mp3",
            "writtenInstructions": "Listen to the reading.",
          },
          {
            "type": "readAloud",
            "audioURL": "https://assets.amiratutor.com/audio/comprehension/uni_the_unicorn_2.mp3",
            "writtenInstructions": "Listen to the reading.",
          },
          {
            "type": "quiz",
            "questions": [
              {
                "text": "Baby elephants suck on their ____ like human babies suck on their thumb.",
                "distractors": [
                  "Toes",
                  "Trunk",
                  "Ear"
                ],
                "correct": "Trunk"
              }
            ]
          },
          {
            "type": "quiz",
            "questions": [
              {
                "text": "An elephant's trunk is a ____ tool.",
                "distractors": [
                  "showering",
                  "eating",
                  "multi-purpose"
                ],
                "correct": "multi-purpose"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "storyId": "15f07e61-3362-437b-8788-69c9ed617aaa",
    "grade": "1",
    "author": " ",
    "title": "Rex",
    "type": "readingComprehension",
    "nonAudio": "true",
    "chapters": [
      {
        "phrases": [
          "Rex",
          "Ball",
        ],
        "items": [
          {
            "type": "quiz",
            "questions": [
              {
                "type": "cloze",
                "distractorFormat": "multi",
                "text": "What did Jim name his new dog?",
                "readQuestion": "true",
                "feedbackMode": "false",
                "distractors": [
                  "Snoop",
                  "Rex",
                  "Buddy"
                ],
                "correct": [
                  "Rex"
                ]
              }
            ]
          },
          {
            "type": "quiz",
            "questions": [
              {
                "type": "cloze",
                "distractorFormat": "multi",
                "text": "What did the dog jump into the pool to get?",
                "readQuestion": "true",
                "feedbackMode": "false",
                "distractors": [
                  "Ball",
                  "Cat",
                  "Goggles"
                ],
                "correct": [
                  "Ball"
                ]
              }
            ]
          },
        ]
      }
    ],
    "questions": []
  },
  {
    "storyId": "15f07e61-3362-437b-8788-69c9ed617aab",
    "grade": "1",
    "author": " ",
    "title": " ",
    "type": "vocabularyScreener",
    "nonAudio": "true",
    "chapters": [
      {
        "phrases": [
          "pig",
          "Ball",
        ],
        "items": [
          {
            "type": "quiz",
            "questions": [
              {
                "type": "cloze",
                "distractorFormat": "multi",
                "text": "Which word pairs best with the word \"goat\"?",
                "readQuestion": "true",
                "feedbackMode": "false",
                "distractors": [
                  "pig",
                  "Aaron Rodgers",
                  "orange"
                ],
                "correct": [
                  "pig"
                ]
              }
            ]
          },
          {
            "type": "quiz",
            "questions": [
              {
                "type": "cloze",
                "distractorFormat": "multi",
                "text": "Choose the word that best fits in this sentence. In some states you can get a driver’s ____ when you are fourteen years old.",
                "readQuestion": "true",
                "feedbackMode": "false",
                "distractors": [
                  "permission",
                  "permissive",
                  "permit",
                ],
                "correct": ["permit"],
              }
            ]
          },,
        ]
      }
    ],
    "questions": []
  },
  {
    "storyId": "032fce6f-f19f-4672-a85f-ba06e7e79bc3",
    "grade": "1",
    "author": " ",
    "title": "Learn About Animals: Pig",
    "type": "tutor",
    "tags": ["PICTURE_STORY"],
    "chapters": [
      {
        "phrases": [
          "This is a pig.",
          "A pig is a fun pet.",
          "A pig can run.",
          "This pig runs in the sun.",
          "A pig can nap.",
          "This pig naps in the mud.",
          "A pig can have spots.",
          "This pig has big spots.",
          "A pig can sit.",
          "This pig sits in a tub.",
          "A pig is a fun pet.",
          "This pig has a wig!",
        ],
        "items": [
          {
            "type": "pictureStoryPage",
            "imageURL": "https://amira-assets.s3.amazonaws.com/story-images/learn-about-animals-pig-1.png",
          },{
            "type": "pictureStoryPage",
            "imageURL": "https://amira-assets.s3.amazonaws.com/story-images/learn-about-animals-pig-2.png",
          },{
            "type": "pictureStoryPage",
            "imageURL": "https://amira-assets.s3.amazonaws.com/story-images/learn-about-animals-pig-3.png",
          },{
            "type": "pictureStoryPage",
            "imageURL": "https://amira-assets.s3.amazonaws.com/story-images/learn-about-animals-pig-4.png",
          },{
            "type": "pictureStoryPage",
            "imageURL": "https://amira-assets.s3.amazonaws.com/story-images/learn-about-animals-pig-5.png",
          },{
            "type": "pictureStoryPage",
            "imageURL": "https://amira-assets.s3.amazonaws.com/story-images/learn-about-animals-pig-6.png",
          },{
            "type": "pictureStoryPage",
            "imageURL": "https://amira-assets.s3.amazonaws.com/story-images/learn-about-animals-pig-7.png",
          },{
            "type": "pictureStoryPage",
            "imageURL": "https://amira-assets.s3.amazonaws.com/story-images/learn-about-animals-pig-8.png",
          },{
            "type": "pictureStoryPage",
            "imageURL": "https://amira-assets.s3.amazonaws.com/story-images/learn-about-animals-pig-9.png",
          },{
            "type": "pictureStoryPage",
            "imageURL": "https://amira-assets.s3.amazonaws.com/story-images/learn-about-animals-pig-10.png",
          },{
            "type": "pictureStoryPage",
            "imageURL": "https://amira-assets.s3.amazonaws.com/story-images/learn-about-animals-pig-11.png",
          },{
            "type": "pictureStoryPage",
            "imageURL": "https://amira-assets.s3.amazonaws.com/story-images/learn-about-animals-pig-12.png",
          },
        ]
      }
    ],
    "questions": []
  },{
    "storyId": "127354dc-6c51-475e-8313-20389d151884",
    "grade": "0",
    "author": " ",
    "title": "Letter Sound B: Word List",
    "type": "tutor",
    "tags": ["PICTURE_STORY", "EARLY_READER_WORD_LIST"],
    "chapters": [
      {
        "phrases": [
          "bell",
          "boots",
          "bee",
          "bird",
          "ball"
        ],
        "items": [{
          "type": "wordList",
          "imageURL": "https://amira-assets.s3.amazonaws.com/word-list-images/b/1.png",
          "introductions": {
            "textIntroductions": {
              "full": "Hello! We are going to practice reading together by learning about sounds and words. The sound we are going to practice in /B/.<img/>We are going to read a poem together and read some words that begin with the sound /B/. Let's see an example!",
              "short": "<img/>You can make this sound by putting your lips together and pushing the sound out. It sounds like this, /B/. You can try it."
            },
            "verbalIntroductions": {
              "full": "<speak>Hello! We are going to practice reading together by learning about sounds and words. The sound we are going to practice is <break time=\"0.7s\"/><prosody rate=\"slow\"><phoneme voice=\"human\" alphabet=\"ipa\" ph=\"b\"/></prosody><break time=\"0.25s\"/> We are going to read a poem together and read some words that begin with the sound <phoneme voice=\"human\" alphabet=\"ipa\" ph=\"b\"/><break time=\"0.25s\"/>Let's see an example!</speak>",
              "short": "<speak>You can make this sound by putting your lips together and pushing the sound out. It sounds like this, <phoneme voice=\"human\" alphabet=\"ipa\" ph=\"b\"/>. You can try it. <break time=\"0.25s\"/></speak>"
            },
            "type": "intro",
            "imageURL": "https://amira-assets.s3.amazonaws.com/word-list-images/b/example.png",
          },
          "instructions": {
            "verbalInstructions": "<speak>Please read the word that matches each picture I show you. For example, here you would say: <break time=\"0.25s\"/> bear. Let's get started</speak>",
            "type": "wordList",
            "text": "bear",
            "imageURL": "https://amira-assets.s3.amazonaws.com/word-list-images/b/example.png", 
          },
        },
          {"type": "wordList", "imageURL": "https://amira-assets.s3.amazonaws.com/word-list-images/b/2.png"},
          {"type": "wordList", "imageURL": "https://amira-assets.s3.amazonaws.com/word-list-images/b/3.png"},
          {"type": "wordList", "imageURL": "https://amira-assets.s3.amazonaws.com/word-list-images/b/4.png"},
          {"type": "wordList", "imageURL": "https://amira-assets.s3.amazonaws.com/word-list-images/b/5.png"},
        ]
      }
    ]
  },{
    "storyId": "8a5646e0-be60-11eb-9ed5-371d0fa60787",
    "grade": "0",
    "author": " ",
    "title": "Baa, Baa Black Sheep",
    "type": "tutor",
    "tags": ["PICTURE_STORY", "EARLY_READER_READ_WITH_ME"],
    "chapters": [
      {
        "phrases": [
          "Baa, baa, black sheep",
          "Have you any wool?"
        ],
        "items": [
          {
            "type": "pictureStoryPage",
            "imageURL": "https://s3.amazonaws.com/amira-assets/images/story-images/8a5646e0-be60-11eb-9ed5-371d0fa60787_1.png",
            "introductions": {
              "textIntroductions": {
                "full": "Hello! We are going to practice reading together by learning about sounds and words. The sound we are going to practice in /B/.<img/>We are going to read a poem together and read some words that begin with the sound /B/. Let's get started!",
                "short": "<img/>You can make this sound by putting your lips together and pushing the sound out. It sounds like this, /B/. You can try it."
              },
              "verbalIntroductions": {
                "full": "<speak>Hello! We are going to practice reading together by learning about sounds and words. <break time=\"0.25s\"/>The sound we are going to practice in <prosody rate=\"x-slow\"><phoneme alphabet=\"ipa\" ph=\"b\"/></prosody>. <break time=\"0.25s\"/> We are going to read a poem together and read some words that begin with the sound <phoneme alphabet=\"ipa\" ph=\"b\"/>. <break time=\"0.25s\"/>Let's get started!</speak>",
                "short": "<speak>You can make this sound by putting your lips together and pushing the sound out. It sounds like this, <phoneme alphabet=\"ipa\" ph=\"b\"/>. You can try it. <break time=\"0.25s\"/></speak>"
              },
              "type": "intro",
              "imageURL": "https://amira-assets.s3.amazonaws.com/word-list-images/b/example.png",
            }
          },
          {
            "type": "pictureStoryPage",
            "imageURL": "https://s3.amazonaws.com/amira-assets/images/story-images/8a5646e0-be60-11eb-9ed5-371d0fa60787_2.png"
          }
        ]
      }
    ],
    "questions": []
  },{
  "storyid": "da28a920-bd60-11eb-88cc-e96adcadf308",
  "grade": "0",
  "version": "1",
   "author": " ",
   "title": "Letter Stories: B",
   "type": "tutor",
   "tags": ["PICTURE_STORY", "EARLY_READER_REPETITIVE_TEXT"],
  "chapters": [{
    "phrases": [
      "I have boots.",
      "I see a butterfly.",
      "I see a bee.",
      "I see a bird.",
      "I play ball."
    ],
    "items": [{
        "type": "pictureStoryPage",
        "imageURL": "https://s3.amazonaws.com/amira-assets/images/story-images/da28a920-bd60-11eb-88cc-e96adcadf308_1.png",
        "introductions": {
          "textIntroductions": {
            "full": "Test new story introduction full",
            "short": "Test new story introduction short"
          },
          "verbalIntroductions": {
            "full": "<speak>Test new story introduction full</speak>",
            "short": "<speak>Test new story introduction short</speak>"
          },
          "type": "pictureStoryPage",
          "imageURL": "https://amira-assets.s3.amazonaws.com/word-list-images/b/example.png",
        },
        "instructions": {
          "verbalInstructions": "<speak>Please read the word that matches each picture I show you. For example, here you would say: <break time=\"0.25s\"/> bear. Let's get started</speak>",
          "type": "pictureStoryPage",
          "text": "bear",
          "imageURL": "https://amira-assets.s3.amazonaws.com/word-list-images/b/example.png", 
        },
      },{
        "type": "pictureStoryPage",
        "imageURL": "https://s3.amazonaws.com/amira-assets/images/story-images/da28a920-bd60-11eb-88cc-e96adcadf308_2.png"
      },{
        "type": "pictureStoryPage",
        "imageURL": "https://s3.amazonaws.com/amira-assets/images/story-images/da28a920-bd60-11eb-88cc-e96adcadf308_3.png"
      },{
        "type": "pictureStoryPage",
        "imageURL": "https://s3.amazonaws.com/amira-assets/images/story-images/da28a920-bd60-11eb-88cc-e96adcadf308_4.png"
      },{
        "type": "pictureStoryPage",
        "imageURL": "https://s3.amazonaws.com/amira-assets/images/story-images/da28a920-bd60-11eb-88cc-e96adcadf308_5.png"
      }]
    }
  ]},
  {
    "grade": "1",
    "author": " ",
    "title": "Change one part assessment 1",
    "storyId": "87a9581b-0989-4b90-acca-db890dce09c2",
    "type": "dyslexia",
    "tags": ['EARLY_READER_CHANGE_ONE_PART'],
    "chapters": [
      {
        "phrases": [
          "run",
          "gum",
          "jump",
          "ham",
        ],
        "items": [
          {
            "type": "changeOnePart",
            "timeoutInMS": 8000,
            "instructions": {
              "verbalInstructions": "these are sample verbal instructions for the change one part type",
              "type": "changeOnePart",
              "playFTUE": "true",
              "example": {
                "originalWord": "bat",
                "targetWord": "cat",
              },
              "text": "rug",
            }
          },
          {
            "type": "changeOnePart",
            "timeoutInMS": 8000,
            "instructions": {
              "type": "changeOnePart",
              "verbalInstructions": "Next, let’s play with the word: mum. Let's change one sound. What's the word?",
              "text": "mum",
            }
          },
          {
            "type": "changeOnePart",
            "timeoutInMS": 8000,
            "instructions": {
              "type": "changeOnePart",
              "verbalInstructions": "Next, let’s play with the word: dump. Let's change one sound. What's the word?",
              "text": "dump",
            }
          },
          {
            "type": "changeOnePart",
            "timeoutInMS": 8000,
            "instructions": {
              "type": "changeOnePart",
              "verbalInstructions": "Next, let’s play with the word: yam. Let's change one sound. What's the word?",
              "text": "yam",
            }
          },
        ]
      }
    ]
  },
  {
    "grade": "1",
    "author": " ",
    "title": "Word part deletion 1",
    "storyId": "f5f97a5d-6d6f-4f3e-9393-bea415afd618",
    "type": "dyslexia",
    "tags": [],
    "chapters": [
      {
        "phrases": [
          "ball",
          "foot",
          "wood",
        ],
        "items": [
          {
            "type": "wordPartDeletion",
            "timeoutInMS": 8000,
            "instructions": {
              "type": "wordPartDeletion", // create a component that runs the Spot commponent
              "text": "baseball",
            }
          },
          {
            "type": "wordPartDeletion",
            "timeoutInMS": 8000,
            "instructions": {
              "type": "wordPartDeletion", // create a component that runs the Spot commponent
              "text": "football",
            }
          },
          {
            "type": "wordPartDeletion",
            "timeoutInMS": 8000,
            "instructions": {
              "type": "wordPartDeletion", // create a component that runs the Spot commponent
              "text": "woodworking",
            }
          },
        ],
      }
    ]
  },
  {
    "grade": "1",
    "author": " ",
    "title": "Nonsense Word Repetition",
    "storyId": "76ba445a-2066-4e12-bbe6-af1b525d95c8",
    "type": "dyslexia",
    "tags": [],
    "chapters": [
      {
        "phrases": [
          "fake",
          "pebble",
          "fake",
          "pebble",
        ],
        "items": [
          {
            "type": "nonsenseWordRepetition",
            "timeoutInMS": 8000,
            "videoURL": "https://s3.amazonaws.com/amira-assets/videos/nonsense_word_video/faekoy.mp4",
            "instructions": {
              "type": "nonsenseWordRepetition",
              "model": "my friend",
            }
          },
          {
            "type": "nonsenseWordRepetition",
            "timeoutInMS": 8000,
            "videoURL": "https://s3.amazonaws.com/amira-assets/videos/nonsense_word_video/peybaw.mp4",
            "instructions": {
              "type": "nonsenseWordRepetition",
              "model": "my friend",
            }
          },
          {
            "type": "nonsenseWordRepetition",
            "timeoutInMS": 8000,
            "videoURL": "https://s3.amazonaws.com/amira-assets/videos/nonsense_word_video/faekoy.mp4",
            "instructions": {
              "type": "nonsenseWordRepetition",
              "model": "my friend",
            }
          },
          {
            "type": "nonsenseWordRepetition",
            "timeoutInMS": 8000,
            "videoURL": "https://s3.amazonaws.com/amira-assets/videos/nonsense_word_video/peybaw.mp4",
            "instructions": {
              "type": "nonsenseWordRepetition",
              "model": "my friend",
            }
          },
        ]
      }
    ]
  },
  {
    "grade": "1",
    "author": " ",
    "title": "Comebined dyslexia new items",
    "storyId": "b51c4f0a-cab6-49cd-a8f9-8be33356f0f9",
    "type": "dyslexia",
    "tags": [],
    "chapters": [
      {
        "phrases": [
          "fan",
          "gum",
          "ball",
          "foot",
          "fake",
          "pebble",
          "two seven four five three eight four two five eight three seven two eight four three five seven four eight two seven five three five two eight three four seven three two five eight seven four",
        ],
        "items": [
          {
            "type": "changeOnePart",
            "timeoutInMS": 8000,
            "instructions": {
              "type": "changeOnePart",
              "text": "far",
            }
          },
          {
            "type": "changeOnePart",
            "timeoutInMS": 8000,
            "instructions": {
              "type": "changeOnePart",
              "text": "mum",
            }
          },
          {
            "type": "wordPartDeletion",
            "timeoutInMS": 8000,
            "instructions": {
              "type": "wordPartDeletion", // create a component that runs the Spot commponent
              "text": "baseball",
            }
          },
          {
            "type": "wordPartDeletion",
            "timeoutInMS": 8000,
            "instructions": {
              "type": "wordPartDeletion", // create a component that runs the Spot commponent
              "text": "football",
            }
          },
          {
            "type": "nonsenseWordRepetition",
            "timeoutInMS": 8000,
            "videoURL": "https://s3.amazonaws.com/amira-assets/videos/nonsense_word_video/faekoy.mp4",
            "instructions": {
              "type": "nonsenseWordRepetition",
              "model": "my friend",
            }
          },
          {
            "type": "nonsenseWordRepetition",
            "timeoutInMS": 8000,
            "videoURL": "https://s3.amazonaws.com/amira-assets/videos/nonsense_word_video/peybaw.mp4",
            "instructions": {
              "type": "nonsenseWordRepetition",
              "model": "my friend",
            }
          },
          {
            "type": "ran",
            "imageURL": "https://s3.amazonaws.com/amira-assets/ran/ran_k.jpg",
            "instructions": {
              "verbalInstructions": "I'm going to show you some things to name. For example, you may see some numbers like the ones on the screen now. You should say these numbers as fast as you can, going from left to right and top to bottom. So, you would say, 1 2 3 4 5 6 7. OK, start naming the numbers as fast as you can",
              "type": "word",
              "text": "1 2 3 4 5 6 7",
              "transition": "readySetGo",
            }
          }
        ]
      }
    ]
  },
  {
    "grade": "0",
    "author": " ",
    "title": "Change one part tutor 1",
    "storyId": "9c96562f-0baf-4155-b21a-8705cc1bf217",
    "type": "tutor",
    "tags": ["EARLY_READER_CHANGE_ONE_PART"],
    "chapters": [
      {
        "phrases": [
          "run",
          "gum",
          "jump",
          "ham",
        ],
        "items": [
          {
            "type": "changeOnePart",
            "instructions": {
              "type": "changeOnePart",
              "verbalInstructions": "these are sample verbal instructions for the change one part type",
              "example": {
                  "originalWord": "bat",
                  "targetWord": "cat",
              },
              "text": "rug",
            },
            "version": 1,
          },
          {
            "type": "changeOnePart",
            "instructions": {
              "type": "changeOnePart",
              "text": "mum",
            },
            "version": 1,
          },
          {
            "type": "changeOnePart",
            "instructions": {
              "type": "changeOnePart",
              "text": "dump",
            },
            "version": 1,
          },
          {
            "type": "changeOnePart",
            "instructions": {
              "type": "changeOnePart",
              "text": "yam",
            },
            "version": 1,
          },
        ]
      }
    ]
  },
  {
    "grade": "0",
    "author": " ",
    "title": "Change one part tutor 2 - non-orthographic",
    "storyId": "f1315712-c6b8-4d8c-8ddd-78b33ed8a2d8",
    "type": "tutor",
    "tags": ["EARLY_READER_CHANGE_ONE_PART"],
    "chapters": [
      {
        "phrases": [
          "run",
          "gum",
          "jump",
          "ham",
        ],
        "items": [
          {
            "type": "changeOnePart",
            "instructions": {
              "type": "changeOnePart",
              "text": "rug",
            },
            "version": 2,
          },
          {
            "type": "changeOnePart",
            "instructions": {
              "type": "changeOnePart",
              "text": "mum",
            },
            "version": 2,
          },
          {
            "type": "changeOnePart",
            "instructions": {
              "type": "changeOnePart",
              "text": "dump",
            },
            "version": 2,
          },
          {
            "type": "changeOnePart",
            "instructions": {
              "type": "changeOnePart",
              "text": "yam",
            },
            "version": 2,
          },
        ]
      }
    ]
  },
  {
    "grade": "0",
    "author": " ",
    "title": "Letterflies tutor 1",
    "storyId": "d30600a6-dff9-4397-bd81-f83fa2316d47",
    "type": "tutor",
    "tags": ["EARLY_READER_LETTER_FLIES"],
    "chapters": [
      {
        "phrases": [
          "æ",
          "æ",
          "æ",
        ],
        "items": [
          {
            "type": "letterFlies",
            "word": "bat",
            "targetGrapheme": "a",
            "instructions": {
              "type": "letterFlies",
              "text": "a", // displayed text in letterflies, the target grapheme.
              "word": "cat", 
              "targetPhoneme": "æ", // phoneme that is spoken as an example
            },
            "introductions": {
              "imageURL": "",
              "textIntroductions": {
               "full": "<img/>",
               "short": "<img/>"
              },
              "type": "intro",
              "verbalIntroductions": {
               "full": "<speak>Hello! We are going to practice reading together by learning about sounds and words. The sound we are going to practice is <phoneme voice=\"human\" alphabet=\"ipa\" ph=\"æ\"/> We are going to do some activities together and read some words that begin with this sound. </speak><speak> You can make this sound by opening your mouth about halfway and pushing the sound from your throat. It sounds like this <phoneme voice=\"human\" alphabet=\"ipa\" ph=\"æ\"/>. You can try it. <break time=\"0.25s\"/></speak>",
               "short": "<speak>Hello! We are going to practice reading together by learning about sounds and words. The sound we are going to practice is <phoneme voice=\"human\" alphabet=\"ipa\" ph=\"æ\"/> We are going to do some activities together and read some words that begin with this sound. </speak><speak> You can make this sound by opening your mouth about halfway and pushing the sound from your throat. It sounds like this <phoneme voice=\"human\" alphabet=\"ipa\" ph=\"æ\"/>. You can try it. <break time=\"0.25s\"/></speak>"
              }
             },
          },
          {
            "type": "letterFlies",
            "word": "fan",
            "targetGrapheme": "a",
            "instructions": {
              "type":"letterFlies",
              "verbalInstructions":"Fan has the <phoneme voice=\"human\" alphabet=\"ipa\" ph=\"æ\"/> sound, which letter makes the <phoneme voice=\"human\" alphabet=\"ipa\" ph=\"æ\"/> sound?"
            },
          },
          {
            "type": "letterFlies",
            "word": "cap",
            "targetGrapheme": "a",
            "instructions":{
              "type":"letterFlies",
              "verbalInstructions":"Cap has the <phoneme voice=\"human\" alphabet=\"ipa\" ph=\"æ\"/> sound, which letter makes the <phoneme voice=\"human\" alphabet=\"ipa\" ph=\"æ\"/> sound?"
           },
          },
        ]
      }
    ]
  },
  { //ELKONIN
    "grade": "1",
    "author": " ",
    "title": "Big Dog",
    "storyid": "9c96562f-0baf-4155-b21a-8705cc1bf220",
    "type": "tutor",
    "tags": ["EARLY_READER_ELKONIN_BOXES"],
    "chapters": [
      {
        "phrases": [
          "dog",
          "big",
          "pet",
          "think",
          "run",
        ],
        "items": [
          {
            "type": "elkonin",
            "instructions": {
              "verbalInstructions": "these instructions should be ignored",
              "text": "tip",
              "type": "elkonin",
            }
          },
          {
            "type": "elkonin",
            "instructions": {
              "verbalInstructions": "The word is: big.",
              "type": "elkonin",
            }
          },
          {
            "type": "elkonin",
            "instructions": {
              "verbalInstructions": "The word is: pet.",
              "type": "elkonin",
            }
          },
          {
            "type": "elkonin",
            "instructions": {
              "verbalInstructions": "The word is: think.",
              "type": "elkonin",
            }
          },
          {
            "type": "elkonin",
            "instructions": {
              "verbalInstructions": "The word is: run.",
              "type": "elkonin",
            }
          },
        ],
      }
    ],
  },
  {
    "storyid": "40ff1a45-ee45-4e97-adc4-86885ededb9c",
    "grade": "0",
    "author": "Amira Learning",
    "title": "i Segmenting Slide - modify for assessment",
    "type": "dyslexia",
    "tags": [],
    "chapters": [
        {
            "phrases": [
                "b ɪ g big",
                "l ɪ p lip",
                "b ɪ n bin",
                "b ɪ b bib"
            ],
            "items": [
                {
                  "type": "upAndDown",
                  "playFTUE": true,
                  "instructions": {
                      "text": "pip",
                      "type": "upAndDown",
                      "verbalInstructions": "<speak>Great job on that part. Watch me do this first.</speak>",
                  },
                  "introductions": {
                    "imageURL": "",
                    "textIntroductions": {
                      "full": "<img/>",
                      "short": "<img/>"
                    },
                    "type": "intro",
                    "verbalIntroductions": {
                      "full": "x",
                      "short": "<speak></speak>"
                    }
                  },
                },
                {
                  "type": "upAndDown",
                  "instructions": {
                      "verbalInstructions": "The word is: lip.",
                      "type": "upAndDown",
                  },
                },
                {
                  "type": "upAndDown",
                  "instructions": {
                      "verbalInstructions": "The word is: bin.",
                      "type": "upAndDown",
                  },
                },
                {
                  "type": "upAndDown",
                  "instructions": {
                      "verbalInstructions": "The word is: bib.",
                      "type": "upAndDown",
                  },
                }
            ],
        }
    ],
  }
];